import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchAllCTOHeadData,
  fetchAllSettlementData,
  fetchAllCTOData,
  fetchCreateNewSettlement,
  fetchAllProfitShareData,
  createNewSettlementInitiate,
  fetchAllGyms,
  fetchAllSettlementCards,
  fetchAllSettlementCharts,
  fetchAllRenewalStats,
  fetchAllRenewalTable,
  fetchAllPastDiscussions,
  fetchAllDiscussionLogs,
  fetchAllRecentRenewal,
  fetchAllAddonsByGym,
  fetchAllAddonSessions,
  fetchAllAddonSlots,
  fetchAllIncentives,
  fetchAllOffersByTypeId,
  checkOfferValidationByUser,
  fetchAllRenewalStatsAll,
  fetchAllRenewalTableAll,
  fetchAllOnlinePaymentLinks,
  fetchAllCashPaymentLinks,
  fetchUserDetailsByMobile,
  fetchAllTrainersByExperienceLevel,
  fetchAllTrainersShiftDetails,
  fetchAllSalesReportByFilterType,
  fetchAllRenewals,
  checkOfferValidationByCode,
  fetchAllFeedbacks,
  fetchAllPTStats,
  fetchPlansPTStats,
  fetchExpiringPTStats,
  fetchPTCharts,
  fetchUpcomingPT,
  fetchAllPTMembers,
  fetchPTTrainers,
  fetchAllPTPlans,
  fetchTopTrainers,
  fetchTrainersOccupancy,
  fetchTrainersMonthlyTaget,
  fetchTrainersTotalMembers,
  fetchLastSales,
  fetchTrainerRatings,
  fetchAssignedMembers,
  fetchTMTA,
  fetchMissedPT,
  fetchAllTrainers,
  fetchTSAR,
  fetchTargetAchieved,
  fetchGymsAttendance,
  fetchAllSubscription,
  fetchAllUnmappedUser,
  fetchPartialPayments,
  fetchAllMeals,
  fetchAllUnits,
  fetchAllWatiLogs,
  fetchAllKeywords,
  fetchSheetTabsStats,
  exportAllUsersDataByChoice,
  fetchIngredients,
  fetchDietTimings,
  fetchPtTracks,
  fetchDietTypes,
  fetchDietPreference,
  fetchPTTrialStats,
  fetchAllReceptionists,
  fetchDieticians,
  fetchExpertise,
  fetchDietStats,
  fetchDietCards,
  fetchAllDietPlan,
  fetchAllDietPackages,
  fetchPTReports,
  fetchMembersById,
  fetchAllPTMemberDatewise,
  fetchSubsTypeSales,
  fetchBiomaxStats,
  fetchTotalCheckins,
  fetchTrainerMembers,
  fetchDefaultTrainers,
  // fetchCto,
  fetchCtoStats,
  fetchTrainerReportsStats,
  fetchMemberLogs,
  fetchDailyTarget,
  fetchAllCampaigns,
  fetchAllJobs,
  fetchActivePtWithExpiredSub,
  fetchLeaveCategories,
  fetchStaffLeaves,
  fetchGTPTtrainer,
  fetchGTPTreports,
  fetchStaffLeaveStats,
  fetchAttendanceChart,
  fetchAttendance,
  fetchAssignedNotAssignedMemberReport,
  fetchApprovalManager,
  fetchAllLeads,
  fetchLeadStats,
  fetchLeadValuesConverted,
  fetchAllGymwisePTStats,
  fetchAllAgents,
  fetchPTPartial,
  fetchURECalendar,
  fetchSubsPartialPending,
  fetchSubsPartialStats,
  fetchRawLeads,
  fetchUREDetails,
  fetchFollowupStatus,
  fetchCustomerIntent,
  fetchPTTrainerPerformance,
  fetchUnassignedLeads,
  fetchRawLeadStats,
  fetchRequestedCupons,
  fetchUREStats,
  fetchCentralisedOffers,
  fetchCartPendingPayments,
  fetchAllPTSalesStats,
  fetchTMEFormSubmission,
  fetchStaffAttendanceReport,
  fetchAgentWiseReport,
  fetchAgentReportDateWise,
  fetchTv,
  fetchAgentReportTaskSop,
  fetchCtoCategories,
  fetchCtoHeads,
  fetchAgreementReport,
  fetchClosureReport,
  fetchClosureReportList,
  fetchOneDayMembership,
  fetchAbandonedCart,
  fetchTMEStats,
  fetchAllTrainer,
  fetchODMAll,
  fetchGymwiseODM,
  fetchSheetContent,
  fetchTvStakeHolder,
  fetchTimeSheet,
  fetchVersionListing,
  fetchGallery,
  fetchCentralizedBenefits,
  fetchNotification,
  fetchTodayPTRevenueDetail,
  fetchLateCheckinsReport,
  fetchLateCheckinsStats,
  fetchTMEActiveUserStats,
  fetchTMEActiveUsers,
  fetchTMEExpiredMembersStats,
  fetchTMEExpiredMembers,
  // fetchSubsPartialPending,
  // fetchSubsPartialStats,
  fetchTickets,
  fetchTicketStats,
  fetchTicketTat,
  fetchUntrackedWatiLeads,
  fetchTvMonitoringDashboard,
  fetchTvMonitoringGymStats,
} from "../../data/APIs";

// // Add new ticket system thunks
// export const fetchTicketsData = createAsyncThunk(
//   "api/fetchTicketsData",
//   async (payload, { getState }) => {
//     const { filters, token } = payload;
//     const response = await fetchTickets(filters, token);
//     return response;
//   }
// );

// export const fetchTicketStatsData = createAsyncThunk(
//   "api/fetchTicketStatsData",
//   async (payload, { getState }) => {
//     const { stats_type, token, filters = {} } = payload;
//     const response = await fetchTicketStats(stats_type, token, filters);
//     return response;
//   }
// );

export const fetchTicketTatData = createAsyncThunk(
  "api/fetchTicketTatData",
  async (payload, { getState }) => {
    const { ticket_id, token } = payload;
    const response = await fetchTicketTat(ticket_id, token);
    return response;
  }
);

export const fetchSettlementData = createAsyncThunk(
  "api/fetchSettlementData",
  async (payload, { getState }) => {
    // const { token } = getState().user; // Get TEMP_TOKEN from user state
    const { queryParameters, token } = payload;
    const response = await fetchAllSettlementData(queryParameters, token);
    return response;
  }
);

export const fetchCTOHead = createAsyncThunk(
  "api/fetchCTOHead",
  async (payload, { getState }) => {
    const { token } = payload;
    const response = await fetchAllCTOHeadData(token);
    return response;
  }
);

export const fetchCTOData = createAsyncThunk(
  "api/fetchCTOData",
  async (payload, { getState }) => {
    const { queryParameters, token } = payload;
    const response = await fetchAllCTOData(queryParameters, token);
    return response;
  }
);

export const fetchCreateNewSettlementData = createAsyncThunk(
  "api/fetchCreateNewSettlementData",
  async (payload, { getState }) => {
    const { queryParameters, token } = payload;
    const response = await fetchCreateNewSettlement(queryParameters, token);
    return response;
  }
);

export const fetchProfitShareData = createAsyncThunk(
  "api/fetchProfitShareData",
  async (payload, { getState }) => {
    const { queryParameters, token } = payload;
    const response = await fetchAllProfitShareData(queryParameters, token);
    return response;
  }
);

export const createNewSettlementInitiateData = createAsyncThunk(
  "api/createNewSettlementInitiateData",
  async (payload, { getState }) => {
    const { queryParameters, token } = payload;
    const response = await createNewSettlementInitiate(queryParameters, token);
    return response;
  }
);

export const fetchAllGymsData = createAsyncThunk(
  "api/fetchAllGymsData",
  async (payload, { getState }) => {
    // const { token } = getState().user; // Get TEMP_TOKEN from user state
    const { page, gymid, token } = payload;
    const response = await fetchAllGyms(page, gymid, token);
    return response;
  }
);

export const fetchAllSettlementCardsData = createAsyncThunk(
  "api/fetchAllSettlementCardsData",
  async (payload, { getState }) => {
    const { queryParameters, token } = payload;
    const response = await fetchAllSettlementCards(queryParameters, token);
    return response;
  }
);

export const fetchAllSettlementChartsData = createAsyncThunk(
  "api/fetchAllSettlementChartsData",
  async (payload, { getState }) => {
    const { queryParameters, token } = payload;
    const response = await fetchAllSettlementCharts(queryParameters, token);
    return response;
  }
);

export const fetchAllRenewalStatsData = createAsyncThunk(
  "api/fetchAllRenewalStatsData",
  async (payload, { getState }) => {
    const { queryParameters, token } = payload;
    const response = await fetchAllRenewalStats(queryParameters, token);
    return response;
  }
);

export const fetchAllRenewalStatsAllData = createAsyncThunk(
  "api/fetchAllRenewalStatsAllData",
  async (payload, { getState }) => {
    const { queryParameters, token } = payload;
    const response = await fetchAllRenewalStatsAll(queryParameters, token);
    return response;
  }
);

export const fetchAllRenewalTableData = createAsyncThunk(
  "api/fetchAllRenewalTableData",
  async (payload, { getState }) => {
    const { pageNo, queryParameters, searchString, token } = payload;
    const response = await fetchAllRenewalTable(
      pageNo,
      queryParameters,
      searchString,
      token
    );
    return response;
  }
);

export const fetchAllRenewalTableAllData = createAsyncThunk(
  "api/fetchAllRenewalTableAllData",
  async (payload, { getState }) => {
    const { queryParameters, searchString, token } = payload;
    const response = await fetchAllRenewalTableAll(
      queryParameters,
      searchString,
      token
    );
    return response;
  }
);

export const fetchAllIncentivesData = createAsyncThunk(
  "api/fetchAllIncentivesData",
  async (payload, { getState }) => {
    const { queryParameters, searchString, token } = payload;
    const response = await fetchAllIncentives(
      queryParameters,
      searchString,
      token
    );
    return response;
  }
);

export const fetchAllPastDiscussionsData = createAsyncThunk(
  "api/fetchAllPastDiscussionsData",
  async (payload, { getState }) => {
    const { queryParameters, token } = payload;
    const response = await fetchAllPastDiscussions(queryParameters, token);
    return response;
  }
);

export const fetchAllPastDiscussionLogsData = createAsyncThunk(
  "api/fetchAllPastDiscussionLogsData",
  async (payload, { getState }) => {
    const { discussionId, token } = payload;
    const response = await fetchAllDiscussionLogs(discussionId, token);
    return response;
  }
);

export const fetchAllRecentRenewalData = createAsyncThunk(
  "api/fetchAllRecentRenewalData",
  async (payload, { getState }) => {
    const { queryParameters, token } = payload;
    const response = await fetchAllRecentRenewal(queryParameters, token);
    return response;
  }
);

export const fetchAllAddonsByGymData = createAsyncThunk(
  "api/fetchAllAddonsByGym",
  async (payload, { getState }) => {
    const { gymId, isPT, token } = payload;
    const response = await fetchAllAddonsByGym(gymId, isPT, token);
    return response;
  }
);

export const fetchAllAddonSessionsData = createAsyncThunk(
  "api/fetchAllAddonSessionsData",
  async (payload, { getState }) => {
    const { addonId, token } = payload;
    const response = await fetchAllAddonSessions(addonId, token);
    return response;
  }
);

export const fetchAllAddonSlotsData = createAsyncThunk(
  "api/fetchAllAddonSlotsData",
  async (payload, { getState }) => {
    const { addonId, slotDate, token } = payload;
    const response = await fetchAllAddonSlots(addonId, slotDate, token);
    return response;
  }
);

export const fetchAllOffersByTypeIdData = createAsyncThunk(
  "api/fetchAllOffersByTypeIdData",
  async (payload, { getState }) => {
    const { typeId, sellingPrice, token } = payload;
    const response = await fetchAllOffersByTypeId(typeId, sellingPrice, token);
    return response;
  }
);

export const checkOfferValidationByCodeData = createAsyncThunk(
  "api/checkOfferValidationByCodeData",
  async (payload, { getState }) => {
    const { typeId, code, token } = payload;
    const response = await checkOfferValidationByCode(typeId, code, token);
    return response;
  }
);

export const fetchAllOnlinePaymentLinksData = createAsyncThunk(
  "api/fetchAllOnlinePaymentLinksData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchAllOnlinePaymentLinks(filters, token);
    return response;
  }
);

export const fetchAllCashPaymentLinksData = createAsyncThunk(
  "api/fetchAllCashPaymentLinksData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchAllCashPaymentLinks(filters, token);
    return response;
  }
);

export const fetchUserDetailsByMobileData = createAsyncThunk(
  "api/fetchUserDetailsByMobileData",
  async (payload, { getState }) => {
    const { userMobile, token, qps } = payload;
    const response = await fetchUserDetailsByMobile(userMobile, token, qps);
    return response;
  }
);

export const fetchAllReceptionistsData = createAsyncThunk(
  "api/fetchAllReceptionistsData",
  async (payload, { getState }) => {
    const { token, qps } = payload;
    const response = await fetchAllReceptionists(token, qps);
    return response;
  }
);

export const checkOfferValidityByUserData = createAsyncThunk(
  "api/checkOfferValidityByUserData",
  async (payload, { getState }) => {
    const { userId, offerId, token } = payload;
    const response = await checkOfferValidationByUser(userId, offerId, token);
    return response;
  }
);

export const fetchAllTrainersByExpLvlData = createAsyncThunk(
  "api/fetchAllTrainersByExpLvlData",
  async (payload, { getState }) => {
    const { queryParameters, token } = payload;
    const response = await fetchAllTrainersByExperienceLevel(
      queryParameters,
      token
    );
    return response;
  }
);

export const fetchAllTrainersSlotsData = createAsyncThunk(
  "api/fetchAllTrainersSlotsData",
  async (payload, { getState }) => {
    const { trainerSlot, token } = payload;
    const response = await fetchAllTrainersShiftDetails(trainerSlot, token);
    return response;
  }
);

export const fetchAllSalesReportByFilterTypeData = createAsyncThunk(
  "api/fetchAllSalesReportByFilterTypeData",
  async (payload, { getState }) => {
    const { pageNo, filterType, queryParameters, searchQuery, token } = payload;
    const response = await fetchAllSalesReportByFilterType(
      pageNo,
      filterType,
      queryParameters,
      searchQuery,
      token
    );
    return response;
  }
);

export const fetchAllRenewalsData = createAsyncThunk(
  "api/fetchAllRenewalsData",
  async (payload, { getState }) => {
    const { pageNo, queryParameters, searchQuery, token } = payload;
    const response = await fetchAllRenewals(
      pageNo,
      queryParameters,
      searchQuery,
      token
    );
    return response;
  }
);

export const fetchAllFeedbacksData = createAsyncThunk(
  "api/fetchAllFeedbacksData",
  async (payload, { getState }) => {
    const { pageNo, queryParameters, token } = payload;
    const response = await fetchAllFeedbacks(pageNo, queryParameters, token);
    return response;
  }
);

export const fetchAllPTStatsData = createAsyncThunk(
  "api/fetchAllPTStatsData",
  async (payload, { getState }) => {
    const { queryParameters, token } = payload;
    const response = await fetchAllPTStats(queryParameters, token);
    return response;
  }
);

export const fetchExpiringPTStatsData = createAsyncThunk(
  "api/fetchExpiringPTStatsData",
  async (payload, { getState }) => {
    const { queryParameters, token } = payload;
    const response = await fetchExpiringPTStats(queryParameters, token);
    return response;
  }
);

export const fetchPlansPTStatsData = createAsyncThunk(
  "api/fetchPlansPTStatsData",
  async (payload, { getState }) => {
    const { queryParameters, token } = payload;
    const response = await fetchPlansPTStats(queryParameters, token);
    return response;
  }
);

export const fetchPTChartsData = createAsyncThunk(
  "api/fetchPTChartsData",
  async (payload, { getState }) => {
    const { queryParameters, token } = payload;
    const response = await fetchPTCharts(queryParameters, token);
    return response;
  }
);

export const fetchTodayPTData = createAsyncThunk(
  "api/fetchTodayPTData",
  async (payload, { getState }) => {
    const { queryParameters, token } = payload;
    const response = await fetchPTCharts(queryParameters, token);
    return response;
  }
);

export const fetchUpcomingPTData = createAsyncThunk(
  "api/fetchUpcomingPTData",
  async (payload, { getState }) => {
    const { pageNo, queryParameters, token } = payload;
    const response = await fetchUpcomingPT(pageNo, queryParameters, token);
    return response;
  }
);

export const fetchAllPTMembersData = createAsyncThunk(
  "api/fetchAllPTMembersData",
  async (payload, { getState }) => {
    const { pageNo, trainerId, searchString, queryParameters, token } = payload;
    const response = await fetchAllPTMembers(
      pageNo,
      trainerId,
      searchString,
      queryParameters,
      token
    );
    return response;
  }
);

export const fetchPTTrainersData = createAsyncThunk(
  "api/fetchPTTrainersData",
  async (payload, { getState }) => {
    const { gymId, token } = payload;
    const response = await fetchPTTrainers(gymId, token);
    return response;
  }
);

export const fetchAllPTPlansData = createAsyncThunk(
  "api/fetchAllPTPlansData",
  async (payload, { getState }) => {
    const { pageNo, trainerId, searchString, queryParameters, token } = payload;
    const response = await fetchAllPTPlans(
      pageNo,
      trainerId,
      searchString,
      queryParameters,
      token
    );
    return response;
  }
);

export const fetchTopTrainersData = createAsyncThunk(
  "api/fetchTopTrainersData",
  async (payload, { getState }) => {
    const { pageNo, searchString, queryParameters, token } = payload;
    const response = await fetchTopTrainers(
      pageNo,
      searchString,
      queryParameters,
      token
    );
    return response;
  }
);

export const fetchTrainersOccupancyData = createAsyncThunk(
  "api/fetchTrainersOccupancyData",
  async (payload, { getState }) => {
    const { queryParameters, token } = payload;
    const response = await fetchTrainersOccupancy(queryParameters, token);
    return response;
  }
);

export const fetchTrainersMonthlyTagetData = createAsyncThunk(
  "api/fetchTrainersMonthlyTagetData",
  async (payload, { getState }) => {
    const { queryParameters, token } = payload;
    const response = await fetchTrainersMonthlyTaget(queryParameters, token);
    return response;
  }
);

export const fetchTrainersTotalMembersData = createAsyncThunk(
  "api/fetchTrainersTotalMembersData",
  async (payload, { getState }) => {
    const { queryParameters, token } = payload;
    const response = await fetchTrainersTotalMembers(queryParameters, token);
    return response;
  }
);

export const fetchLastSalesData = createAsyncThunk(
  "api/fetchLastSalesData",
  async (payload, { getState }) => {
    const { queryParameters, token, pageNo, limit } = payload;
    const response = await fetchLastSales(
      queryParameters,
      token,
      pageNo,
      limit
    );
    return response;
  }
);

export const fetchTrainerRatingsData = createAsyncThunk(
  "api/fetchTrainerRatingsData",
  async (payload, { getState }) => {
    const { queryParameters, token } = payload;
    const response = await fetchTrainerRatings(queryParameters, token);
    return response;
  }
);

export const fetchAssignedMembersData = createAsyncThunk(
  "api/fetchAssignedMembersData",
  async (payload, { getState }) => {
    const { queryParameters, token } = payload;
    const response = await fetchAssignedMembers(queryParameters, token);
    return response;
  }
);

export const fetchTMTAData = createAsyncThunk(
  "api/fetchTMTAData",
  async (payload, { getState }) => {
    const { queryParameters, token } = payload;
    const response = await fetchTMTA(queryParameters, token);
    return response;
  }
);

export const fetchTMTAData2 = createAsyncThunk(
  "api/fetchTMTAData2",
  async (payload, { getState }) => {
    const { queryParameters, token } = payload;
    const response = await fetchTMTA(queryParameters, token);
    return response;
  }
);

export const fetchMissedPTData = createAsyncThunk(
  "api/fetchMissedPTData",
  async (payload, { getState }) => {
    const { queryParameters, token } = payload;
    const response = await fetchMissedPT(queryParameters, token);
    return response;
  }
);

export const fetchAllTrainersData = createAsyncThunk(
  "api/fetchAllTrainersData",
  async (payload, { getState }) => {
    const { pageNo, search, queryParameters, token } = payload;
    const response = await fetchAllTrainers(
      pageNo,
      search,
      queryParameters,
      token
    );
    return response;
  }
);

export const fetchTSARData = createAsyncThunk(
  "api/fetchTSARData",
  async (payload, { getState }) => {
    const { queryParameters, token } = payload;
    const response = await fetchTSAR(queryParameters, token);
    return response;
  }
);

export const fetchTargetAchievedData = createAsyncThunk(
  "api/fetchTargetAchievedData",
  async (payload, { getState }) => {
    const { queryParameters, token } = payload;
    const response = await fetchTargetAchieved(queryParameters, token);
    return response;
  }
);

export const fetchTargetAchievedData1 = createAsyncThunk(
  "api/fetchTargetAchievedData1",
  async (payload, { getState }) => {
    const { queryParameters, token } = payload;
    const response = await fetchTargetAchieved(queryParameters, token);
    return response;
  }
);

export const fetchGymsAttendanceData = createAsyncThunk(
  "api/fetchGymsAttendanceData",
  async (payload, { getState }) => {
    const { queryParameters, token } = payload;
    const response = await fetchGymsAttendance(queryParameters, token);
    return response;
  }
);

export const fetchGymsAttendanceDetailedData = createAsyncThunk(
  "api/fetchGymsAttendanceDetailedData",
  async (payload, { getState }) => {
    const { queryParameters, token } = payload;
    const response = await fetchGymsAttendance(queryParameters, token);
    return response;
  }
);

export const fetchTargetAchievedDetailsData = createAsyncThunk(
  "api/fetchTargetAchievedDetailsData",
  async (payload, { getState }) => {
    const { queryParameters, token } = payload;
    const response = await fetchTargetAchieved(queryParameters, token);
    return response;
  }
);

export const fetchAllSubscriptionData = createAsyncThunk(
  "api/fetchAllSubscriptionData",
  async (payload, { getState }) => {
    // const { pageNo, queryParameters, token, pageLimit } = payload;
    // const response = await fetchAllSubscription(
    //   pageNo,
    //   queryParameters,
    //   token,
    //   pageLimit
    // );
    const { filters, token } = payload;
    const response = await fetchAllSubscription(filters, token);
    return response;
  }
);

export const exportAllSubscriptionData = createAsyncThunk(
  "api/exportAllSubscriptionData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchAllSubscription(filters, token);
    return response;
  }
);

export const fetchAllUnmappedUserData = createAsyncThunk(
  "api/fetchAllUnmappedUserData",
  async (payload, { getState }) => {
    const { pageNo, pageLimit, queryParameters, token } = payload;
    const response = await fetchAllUnmappedUser(
      pageNo,
      pageLimit,
      queryParameters,
      token
    );
    return response;
  }
);

export const fetchPartialPaymentsData = createAsyncThunk(
  "api/fetchPartialPaymentsData",
  async (payload, { getState }) => {
    const { pageNo, queryParameters, searchString, token } = payload;
    const response = await fetchPartialPayments(
      pageNo,
      queryParameters,
      searchString,
      token
    );
    return response;
  }
);

export const fetchAllMealsData = createAsyncThunk(
  "api/fetchAllMealsData",
  async (payload, { getState }) => {
    const { pageNo, limit, queryParameters, token } = payload;
    const response = await fetchAllMeals(pageNo, limit, queryParameters, token);
    return response;
  }
);

export const fetchIngredientsData = createAsyncThunk(
  "api/fetchIngredientsData",
  async (payload, { getState }) => {
    const { pageNo, limit, queryParameters, token } = payload;
    const response = await fetchIngredients(
      pageNo,
      limit,
      queryParameters,
      token
    );
    return response;
  }
);

export const fetchAllUnitsData = createAsyncThunk(
  "api/fetchAllUnitsData",
  async (payload, { getState }) => {
    const { token, pageNo, limit } = payload;
    const response = await fetchAllUnits(token, pageNo, limit);
    return response;
  }
);

export const fetchAllWatiLogsData = createAsyncThunk(
  "api/fetchAllWatiLogsData",
  async (payload, { getState }) => {
    const { pageNo, queryParameters, token } = payload;
    const response = await fetchAllWatiLogs(pageNo, queryParameters, token);
    return response;
  }
);

export const fetchAllKeywordsData = createAsyncThunk(
  "api/fetchAllKeywordsData",
  async (payload, { getState }) => {
    const { pageNo, queryParameters, token } = payload;
    const response = await fetchAllKeywords(pageNo, queryParameters, token);
    return response;
  }
);

export const fetchSheetTabsStatsData = createAsyncThunk(
  "api/fetchSheetTabsStatsData",
  async (payload, { getState }) => {
    const { queryParameters, token } = payload;
    const response = await fetchSheetTabsStats(queryParameters, token);
    return response;
  }
);

export const exportAllUsersDataByChoiceData = createAsyncThunk(
  "api/exportAllUsersDataByChoiceData",
  async (payload, { getState }) => {
    const { queryParameters, token } = payload;
    const response = await exportAllUsersDataByChoice(queryParameters, token);
    return response;
  }
);

export const fetchDietTimingsData = createAsyncThunk(
  "api/fetchDietTimingsData",
  async (payload, { getState }) => {
    const { pageNo, limit, queryParameters, token } = payload;
    const response = await fetchDietTimings(
      pageNo,
      limit,
      queryParameters,
      token
    );
    return response;
  }
);

export const fetchDietTypesData = createAsyncThunk(
  "api/fetchDietTypesData",
  async (payload, { getState }) => {
    const { pageNo, limit, queryParameters, token } = payload;
    const response = await fetchDietTypes(
      pageNo,
      limit,
      queryParameters,
      token
    );
    return response;
  }
);

export const fetchDietPreferenceData = createAsyncThunk(
  "api/fetchDietPreferenceData",
  async (payload, { getState }) => {
    const { pageNo, limit, queryParameters, token } = payload;
    const response = await fetchDietPreference(
      pageNo,
      limit,
      queryParameters,
      token
    );
    return response;
  }
);

export const fetchPTTrialStatsData = createAsyncThunk(
  "api/fetchPTTrialStatsData",
  async (payload, { getState }) => {
    const { queryParameters, token } = payload;
    const response = await fetchPTTrialStats(queryParameters, token);
    return response;
  }
);

export const fetchPtTracksData = createAsyncThunk(
  "api/fetchPtTracksData",
  async (payload, { getState }) => {
    const { pageNo, limit, queryParameters, token } = payload;
    const response = await fetchPtTracks(pageNo, limit, queryParameters, token);
    return response;
  }
);

export const fetchPTReportsData = createAsyncThunk(
  "api/fetchPTReportsData",
  async (payload, { getState }) => {
    const { pageNo, limit, queryParameters, token } = payload;
    const response = await fetchPTReports(
      pageNo,
      limit,
      queryParameters,
      token
    );
    return response;
  }
);

export const totalSubsGymwiseData = createAsyncThunk(
  "api/totalSubsGymwiseData",
  async (payload, { getState }) => {
    const { pageNo, limit, queryParameters, token } = payload;
    const response = await fetchPtTracks(pageNo, limit, queryParameters, token);
    return response;
  }
);

export const totalHandoverByMeData = createAsyncThunk(
  "api/totalHandoverByMeData",
  async (payload, { getState }) => {
    const { pageNo, limit, queryParameters, token } = payload;
    const response = await fetchPtTracks(pageNo, limit, queryParameters, token);
    return response;
  }
);

export const totalTrialInitiatedByMeData = createAsyncThunk(
  "api/totalTrialInitiatedByMeData",
  async (payload, { getState }) => {
    const { pageNo, limit, queryParameters, token } = payload;
    const response = await fetchPtTracks(pageNo, limit, queryParameters, token);
    return response;
  }
);

export const fetchPtTracksDataCheck = createAsyncThunk(
  "api/fetchPtTracksDataCheck",
  async (payload, { getState }) => {
    const { pageNo, limit, queryParameters, token } = payload;
    const response = await fetchPtTracks(pageNo, limit, queryParameters, token);
    return response;
  }
);

export const fetchDieticiansData = createAsyncThunk(
  "api/fetchDieticiansData",
  async (payload, { getState }) => {
    const { pageNo, limit, queryParameters, token } = payload;
    const response = await fetchDieticians(
      pageNo,
      limit,
      queryParameters,
      token
    );
    return response;
  }
);

export const fetchExpertiseData = createAsyncThunk(
  "api/fetchExpertiseData",
  async (payload, { getState }) => {
    const { pageNo, limit, queryParameters, token } = payload;
    const response = await fetchExpertise(
      pageNo,
      limit,
      queryParameters,
      token
    );
    return response;
  }
);

export const fetchDietStatsData = createAsyncThunk(
  "api/fetchDietStatsData",
  async (payload, { getState }) => {
    const { queryParameters, token } = payload;
    const response = await fetchDietStats(queryParameters, token);
    return response;
  }
);

export const fetchDietCardsData = createAsyncThunk(
  "api/fetchDietCardsData",
  async (payload, { getState }) => {
    const { pageNo, limit, queryParameters, token } = payload;
    const response = await fetchDietCards(
      pageNo,
      limit,
      queryParameters,
      token
    );
    return response;
  }
);

export const fetchAllDietPlanData = createAsyncThunk(
  "api/fetchAllDietPlanData",
  async (payload, { getState }) => {
    const { pageNo, limit, queryParameters, token } = payload;
    const response = await fetchAllDietPlan(
      pageNo,
      limit,
      queryParameters,
      token
    );
    return response;
  }
);

export const fetchAllDietPackagesData = createAsyncThunk(
  "api/fetchAllDietPackagesData",
  async (payload, { getState }) => {
    const { pageNo, limit, queryParameters, token } = payload;
    const response = await fetchAllDietPackages(
      pageNo,
      limit,
      queryParameters,
      token
    );
    return response;
  }
);

export const fetchFreeDietPackagesData = createAsyncThunk(
  "api/fetchFreeDietPackagesData",
  async ({ pageNo, limit, queryParameters, token }, { getState }) => {
    const response = await fetchAllDietPackages(
      pageNo,
      limit,
      queryParameters,
      token
    );
    return response;
  }
);

export const fetchPaidDietPackagesData = createAsyncThunk(
  "api/fetchPaidDietPackagesData",
  async ({ pageNo, limit, queryParameters, token }, { getState }) => {
    const response = await fetchAllDietPackages(
      pageNo,
      limit,
      queryParameters,
      token
    );
    return response;
  }
);

export const fetchMembersByIdData = createAsyncThunk(
  "api/fetchMembersByIdData",
  async ({ memId, queryParameters, token }, { getState }) => {
    const response = await fetchMembersById(memId, queryParameters, token);
    return response;
  }
);

export const fetchPTMemberDatewiseData = createAsyncThunk(
  "api/fetchPTMemberDatewiseData",
  async (payload, { getState }) => {
    const { pageNo, date, qp, token } = payload;
    const response = await fetchAllPTMemberDatewise(pageNo, date, qp, token);
    return response;
  }
);

export const fetchStaffTargetsData = createAsyncThunk(
  "api/fetchStaffTargetsData",
  async (payload, { getState }) => {
    const { queryParameters, token } = payload;
    const response = await fetchTrainersMonthlyTaget(queryParameters, token);
    return response;
  }
);

export const fetchSubsTypeSalesData = createAsyncThunk(
  "api/fetchSubsTypeSalesData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchSubsTypeSales(filters, token);
    return response;
  }
);

export const fetchBiomaxMemberStatsData = createAsyncThunk(
  "api/fetchBiomaxMemberStatsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchBiomaxStats(filters, token);
    return response;
  }
);

export const fetchTotalCheckinsData = createAsyncThunk(
  "api/fetchTotalCheckinsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchTotalCheckins(filters, token);
    return response;
  }
);

export const fetchTrainerReportsStatsData = createAsyncThunk(
  "api/fetchTrainerReportsStatsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchTrainerReportsStats(filters, token);
    return response;
  }
);

export const fetchGTPTreportsStats = createAsyncThunk(
  "api/fetchGTPTreportsStats",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchGTPTreports(filters, token);
    return response;
  }
);

export const fetchDefaultTrainersData = createAsyncThunk(
  "api/fetchDefaultTrainersData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchDefaultTrainers(filters, token);
    return response;
  }
);

export const fetchGTPTreportsDetails = createAsyncThunk(
  "api/fetchGTPTreportsDetails",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchGTPTreports(filters, token);
    return response;
  }
);

export const fetchTrainerMembersData = createAsyncThunk(
  "api/fetchTrainerMembersData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchTrainerMembers(filters, token);
    return response;
  }
);

export const fetchCtoCategoriesData = createAsyncThunk(
  "api/fetchCtoCategoriesData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchCtoCategories(filters, token);
    return response;
  }
);

export const fetchCtoHeadsData = createAsyncThunk(
  "api/fetchCtoHeadsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchCtoHeads(filters, token);
    return response;
  }
);

export const fetchCtoStatsData = createAsyncThunk(
  "api/fetchCtoStatsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchCtoStats(filters, token);
    return response;
  }
);

export const fetchMemberLogsData = createAsyncThunk(
  "api/fetchMemberLogsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchMemberLogs(filters, token);
    return response;
  }
);

export const fetchDailyTargetData = createAsyncThunk(
  "api/fetchDailyTargetData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchDailyTarget(filters, token);
    return response;
  }
);

export const fetchDailyTargetStatsData = createAsyncThunk(
  "api/fetchDailyTargetStatsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchDailyTarget(filters, token);
    return response;
  }
);

export const fetchAllCampaignsData = createAsyncThunk(
  "api/fetchAllCampaignsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchAllCampaigns(filters, token);
    return response;
  }
);

export const fetchAllJobsState = createAsyncThunk(
  "api/fetchAllJobsState",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchAllJobs(filters, token);
    return response;
  }
);

export const fetchAllJobsData = createAsyncThunk(
  "api/fetchAllJobsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchAllJobs(filters, token);
    return response;
  }
);

export const fetchActivePtWithExpiredSubStats = createAsyncThunk(
  "api/fetchActivePtWithExpiredSubStats",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchActivePtWithExpiredSub(filters, token);
    return response;
  }
);

export const fetchActivePtWithExpiredSubData = createAsyncThunk(
  "api/fetchActivePtWithExpiredSubData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchActivePtWithExpiredSub(filters, token);
    return response;
  }
);

export const fetchLeaveCategoriesData = createAsyncThunk(
  "api/fetchLeaveCategoriesData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchLeaveCategories(filters, token);
    return response;
  }
);

export const fetchApprovalManagerData = createAsyncThunk(
  "api/fetchApprovalManagerData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchApprovalManager(filters, token);
    return response;
  }
);

export const fetchStaffLeavesData = createAsyncThunk(
  "api/fetchStaffLeavesData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchStaffLeaves(filters, token);
    return response;
  }
);

export const fetchStaffLeaveStatsData = createAsyncThunk(
  "api/fetchStaffLeaveStatsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchStaffLeaveStats(filters, token);
    return response;
  }
);

export const fetchStaffLeaveYearStats = createAsyncThunk(
  "api/fetchStaffLeaveYearStats",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchStaffLeaveStats(filters, token);
    return response;
  }
);

export const fetchGTPTtrainersStats = createAsyncThunk(
  "api/fetchGTPTtrainersStats",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchGTPTtrainer(filters, token);
    return response;
  }
);

export const fetchAttendanceChartData = createAsyncThunk(
  "api/fetchAttendanceChartData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchAttendanceChart(filters, token);
    return response;
  }
);

export const fetchAttendanceChartData2 = createAsyncThunk(
  "api/fetchAttendanceChartData2",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchAttendanceChart(filters, token);
    return response;
  }
);

export const fetchTrainerAttendanceData = createAsyncThunk(
  "api/fetchTrainerAttendanceData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchAttendance(filters, token);
    return response;
  }
);

export const fetchReceptionistAttendance = createAsyncThunk(
  "api/fetchReceptionistAttendance",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchAttendance(filters, token);
    return response;
  }
);

export const fetchTrainerAssignedMembersData = createAsyncThunk(
  "api/fetchTrainerAssignedMembersData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchAssignedNotAssignedMemberReport(filters, token);
    return response;
  }
);

export const fetchTrainerNotAssignedMembersData = createAsyncThunk(
  "api/fetchTrainerNotAssignedMembersData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchAssignedNotAssignedMemberReport(filters, token);
    return response;
  }
);

export const fetchLeadsStatsData = createAsyncThunk(
  "api/fetchLeadsStatsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchLeadStats(filters, token);
    return response;
  }
);

export const fetchAllLeadsData = createAsyncThunk(
  "api/fetchAllLeadsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchAllLeads(filters, token);
    return response;
  }
);

export const fetchLeadValuesConvertedData = createAsyncThunk(
  "api/fetchLeadValuesConvertedData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchLeadValuesConverted(filters, token);
    return response;
  }
);

export const fetchRawLeadsData = createAsyncThunk(
  "api/fetchRawLeadsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchRawLeads(filters, token);
    return response;
  }
);

export const fetchAllGymwisePTStatsData = createAsyncThunk(
  "api/fetchAllGymwisePTStatsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchAllGymwisePTStats(filters, token);
    return response;
  }
);

export const fetchAllAgentsData = createAsyncThunk(
  "api/fetchAllAgentsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchAllAgents(filters, token);
    return response;
  }
);

export const fetchPTPartialData = createAsyncThunk(
  "api/fetchPTPartialData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchPTPartial(filters, token);
    return response;
  }
);

export const fetchURECalendarData = createAsyncThunk(
  "api/fetchURECalendarData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchURECalendar(filters, token);
    return response;
  }
);

export const fetchUREDetailsData = createAsyncThunk(
  "api/fetchUREDetailsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchUREDetails(filters, token);
    return response;
  }
);

export const fetchSubsPartialStatsData = createAsyncThunk(
  "api/fetchSubsPartialStatsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchSubsPartialStats(filters, token);
    return response;
  }
);

export const fetchSubsPartialPendingData = createAsyncThunk(
  "api/fetchSubsPartialPendingData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchSubsPartialPending(filters, token);
    return response;
  }
);

export const fetchFollowupStatusData = createAsyncThunk(
  "api/fetchFollowupStatusData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchFollowupStatus(filters, token);
    return response;
  }
);

export const fetchCustomerIntentData = createAsyncThunk(
  "api/fetchCustomerIntentData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchCustomerIntent(filters, token);
    return response;
  }
);

export const fetchPTTrainerPerformanceData = createAsyncThunk(
  "api/fetchPTTrainerPerformanceData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchPTTrainerPerformance(filters, token);
    return response;
  }
);

export const fetchUnassignedLeadsData = createAsyncThunk(
  "api/fetchUnassignedLeadsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchUnassignedLeads(filters, token);
    return response;
  }
);

export const fetchRawLeadStatsData = createAsyncThunk(
  "api/fetchRawLeadStatsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchRawLeadStats(filters, token);
    return response;
  }
);

export const fetchRequestedCuponsData = createAsyncThunk(
  "api/fetchRequestedCuponsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchRequestedCupons(filters, token);
    return response;
  }
);

export const fetchUREStatsData = createAsyncThunk(
  "api/fetchUREStatsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchUREStats(filters, token);
    return response;
  }
);

export const fetchCentralisedOffersData = createAsyncThunk(
  "api/fetchCentralisedOffersData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchCentralisedOffers(filters, token);
    return response;
  }
);

export const fetchCartPendingPaymentsData = createAsyncThunk(
  "api/fetchCartPendingPaymentsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchCartPendingPayments(filters, token);
    return response;
  }
);

export const fetchAllPTSalesStatsData = createAsyncThunk(
  "api/fetchAllPTSalesStatsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchAllPTSalesStats(filters, token);
    return response;
  }
);

export const fetchTMEStatsData = createAsyncThunk(
  "api/fetchTMEStatsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchTMEStats(filters, token);
    return response;
  }
);

export const fetchTMEActiveUserStatsData = createAsyncThunk(
  "api/fetchTMEActiveUserStatsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchTMEActiveUserStats(filters, token);
    return response;
  }
);

export const fetchTMEExpiredMembersStatsData = createAsyncThunk(
  "api/fetchTMEExpiredMembersStatsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchTMEExpiredMembersStats(filters, token);
    return response;
  }
);

export const fetchTMEExpiredMembersData = createAsyncThunk(
  "api/fetchTMEExpiredMembersData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchTMEExpiredMembers(filters, token);
    return response;
  }
);

export const fetchTMEFormSubmissionData = createAsyncThunk(
  "api/fetchTMEFormSubmissionData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchTMEFormSubmission(filters, token);
    return response;
  }
);

export const fetchTMEActiveUsersData = createAsyncThunk(
  "api/fetchTMEActiveUsersData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchTMEActiveUsers(filters, token);
    return response;
  }
);

export const fetchStaffAttendanceReportData = createAsyncThunk(
  "api/fetchStaffAttendanceReportData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchStaffAttendanceReport(filters, token);
    return response;
  }
);

export const fetchLateCheckinsReportData = createAsyncThunk(
  "api/fetchLateCheckinsReportData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchLateCheckinsReport(filters, token);
    return response;
  }
);

export const fetchLateCheckinsStatsData = createAsyncThunk(
  "api/fetchLateCheckinsStatsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchLateCheckinsStats(filters, token);
    return response;
  }
);

export const fetchAgentReportDateWiseData = createAsyncThunk(
  "api/fetchAgentReportDateWiseData",
  async (payload, { getState }) => {
    const response = await fetchAgentReportDateWise(payload);
    return response;
  }
);

export const fetchAgentWiseReportData = createAsyncThunk(
  "api/fetchAgentReportWiseData",
  async (payload, { getState }) => {
    const response = await fetchAgentWiseReport(payload);
    return response;
  }
);

export const fetchAgentReportTaskSopData = createAsyncThunk(
  "api/fetchAgentReportTaskSopData",
  async (payload, { getState }) => {
    const response = await fetchAgentReportTaskSop(payload);
    return response;
  }
);

export const fetchTvData = createAsyncThunk(
  "api/fetchTvData",
  async (payload, { getState }) => {
    const { filters, token } = payload;

    const response = await fetchTv(filters, token);
    return response;
  }
);
export const fetchTvStakeHolderData = createAsyncThunk(
  "api/fetchTvStakeHolderData",
  async (payload, { getState }) => {
    const { filters, token } = payload;

    const response = await fetchTvStakeHolder(filters, token);
    return response;
  }
);

export const fetchAgreementReportData = createAsyncThunk(
  "api/fetchAgreementReportData",
  async (payload, { getState }) => {
    const { filters, token } = payload;

    const response = await fetchAgreementReport(filters, token);
    return response;
  }
);

export const fetchClosureReportData = createAsyncThunk(
  "api/fetchClosureReportData",
  async (payload, { getState }) => {
    const { filters, token } = payload;

    const response = await fetchClosureReport(filters, token);
    return response;
  }
);

export const fetchClosureReportListData = createAsyncThunk(
  "api/fetchClosureReportListData",
  async (payload, { getState }) => {
    const { filters, token } = payload;

    const response = await fetchClosureReportList(filters, token);
    return response;
  }
);

export const fetchOneDayMembershipData = createAsyncThunk(
  "api/fetchOneDayMembershipData",
  async (payload, { getState }) => {
    const { filters, token } = payload;

    const response = await fetchOneDayMembership(filters, token);
    return response;
  }
);

export const fetchAbandonedCartData = createAsyncThunk(
  "api/fetchAbandonedCartData",
  async (payload, { getState }) => {
    const { filters, token } = payload;

    const response = await fetchAbandonedCart(filters, token);
    return response;
  }
);
export const fetchAllTrainerData = createAsyncThunk(
  "api/fetchAllTrainerData",
  async (payload, { getState }) => {
    const { filters, token } = payload;

    // console.log("payload on slice==>", payload);

    const response = await fetchAllTrainer(filters, token);
    return response;
  }
);

export const fetchODMAllData = createAsyncThunk(
  "api/fetchODMAllData",
  async (payload, { getState }) => {
    const { filters, token } = payload;

    const response = await fetchODMAll(filters, token);
    return response;
  }
);

export const fetchGymwiseODMData = createAsyncThunk(
  "api/fetchGymwiseODMData",
  async (payload, { getState }) => {
    const { filters, token } = payload;

    const response = await fetchGymwiseODM(filters, token);
    return response;
  }
);

export const fetchTimeSheetData = createAsyncThunk(
  "api/fetchTimeSheetData",
  async (payload, { getState }) => {
    const { filters, token } = payload;

    const response = await fetchTimeSheet(filters, token);
    return response;
  }
);

export const fetchSheetContentData = createAsyncThunk(
  "api/fetchSheetContentData",
  async (payload, { getState }) => {
    const { uid, token } = payload;

    const response = await fetchSheetContent(uid, token);
    return response;
  }
);

export const fetchVersionListingData = createAsyncThunk(
  "api/fetchVersionListing",
  async (payload, { getState }) => {
    const { filters, token } = payload;

    const response = await fetchVersionListing(filters, token);
    return response;
  }
);

export const fetchGalleryData = createAsyncThunk(
  "api/gallery",
  async (payload, { getState }) => {
    const { token, filters } = payload;

    const response = await fetchGallery(token, filters);
    return response;
  }
);

export const fetchCentralizedBenefitsData = createAsyncThunk(
  "api/fetchCentralizedBenefitsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;

    const response = await fetchCentralizedBenefits(token, filters);
    return response;
  }
);

export const fetchNotificationData = createAsyncThunk(
  "api/fetchNotificationData",
  async (payload, { getState }) => {
    const { filters, token } = payload;

    const response = await fetchNotification(token, filters);
    return response;
  }
);

export const fetchTodayPTRevenueDetailData = createAsyncThunk(
  "api/fetchTodayPTRevenueDetailData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchTodayPTRevenueDetail(filters, token);
    return response;
  }
);

export const fetchUntrackedWatiLeadsData = createAsyncThunk(
  "api/fetchUntrackedWatiLeadsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchUntrackedWatiLeads(filters, token);
    return response;
  }
);

// export const fetchLeadsOwnerData = createAsyncThunk(
//   "api/fetchLeadsOwnerData",
//   async (payload, { getState }) => {
//     const { filters, token } = payload;
//     const response = await fetchLeadStats(filters, token);
//     return response;
//   }
// );

// TV Monitoring Dashboard (ported from main). Read-only dashboard over TV
// heartbeat data; the two thunks back the dashboard + gym-stats views.
export const fetchTvMonitoringDashboardData = createAsyncThunk(
  "api/fetchTvMonitoringDashboardData",
  async (payload) => {
    const { filters, token } = payload;
    const response = await fetchTvMonitoringDashboard(filters, token);
    return response;
  }
);

export const fetchTvMonitoringGymStatsData = createAsyncThunk(
  "api/fetchTvMonitoringGymStatsData",
  async (payload) => {
    const { token } = payload;
    const response = await fetchTvMonitoringGymStats(token);
    return response;
  }
);

const apiSlice = createSlice({
  name: "api",
  initialState: {
    // TV Monitoring Dashboard
    tvMonitoringDashboard: null,
    tvMonitoringDashboardLoading: false,
    tvMonitoringDashboardError: null,
    tvMonitoringGymStats: null,
    tvMonitoringGymStatsLoading: false,

    settlementData: null,
    ctoHeadData: null,
    ctoData: null,
    searchedSettlementData: null,
    profitShareData: null,
    allGymsGstIncludedData: null,
    initiateData: null,
    settlementCardData: null,
    settlementChartsData: null,
    renewalsStatsData: null,
    renewalsStatsAllData: null,
    renewalTableData: null,
    renewalTableAllData: null,
    pastDiscussionsData: null,
    discussionLogsData: null,
    recentRenewalData: null,
    allAddonsByGymData: null,
    allAddonSessions: null,
    allAddonSlots: null,
    allIncentivesData: null,
    allOffersByTypeIdData: null,
    offerValidityCheckByUser: null,

    allOnlinePaymentLinkData: null,
    allOnlinePaymentLinkDataError: null,
    allOnlinePaymentLinkDataLoading: false,

    allCashPaymentData: null,
    allCashPaymentDataError: null,
    allCashPaymentDataLoading: false,

    userDetailsByMobile: null,
    allTrainerByExpLvlData: null,
    trainerSlotDetails: null,
    salesReportsBuFiltertypeData: null,
    allRenewalsData: null,
    allFeedbacksData: null,
    allPTStatsData: null,
    expiringPTStatsData: null,
    plansPTStatsData: null,
    ptChartsData: null,
    todayPT: null,
    upcomingPTData: null,
    ptMembersData: null,
    allPTTrainersData: null,
    allPTPlansData: null,
    topTrainersData: null,
    trainerOccupancyData: null,
    trainersMonthlyTargetData: null,
    trainersTotalMembersData: null,
    lastSalesData: null,
    trainerRatingsData: null,
    assignedMembersData: null,
    tmtaData: null,
    tmtaData2: null,
    missedPTData: null,
    allTrainersData: null,
    tsarData: null,
    achievedTargetData: null,
    achievedTargetData1: null,
    allGymAttendanceData: null,

    allSubscriptionData: null,
    allSubscriptionDataLoading: false,
    allSubscriptionDataError: null,

    exportedSubscriptionData: null,
    exportedSubscriptionDataLoading: false,
    exportedSubscriptionDataError: null,

    unmappedUserData: null,
    partialPaymentsData: null,
    allMealsData: null,
    ingData: null,
    allUnitsData: null,

    watiLogs: null,
    watilogsLoading: false,

    allKeywords: null,
    keywordLoading: false,

    sheetAndTabs: null,
    usersExportedData: null,
    dietTimingsData: null,
    dietTypesData: null,
    dietPreferenceData: null,

    ptTracksData: null,
    ptTracksDataLoading: false,
    ptTracksDataError: null,

    totalSubscriptionGymwise: null,
    totalSubscriptionGymwiseLoading: false,
    totalSubscriptionGymwiseError: null,

    ptTracksDataCheck: null,
    dieticiansData: null,
    ptTrialStatsData: null,
    ptReportsData: null,
    allRecepData: null,

    handoverByMe: null,
    handoverByMeLoading: false,
    handoverByMeError: null,

    trialInitiatedByMe: null,
    trialInitiatedByMeLoading: false,
    trialInitiatedByMeError: null,

    expertiseData: null,
    dietStatsData: null,
    dietCardsData: null,
    dietPlansData: null,
    dietPackagesData: null,
    freeDietPackages: null,
    paidDietPackages: null,
    memberById: null,
    gymAttendanceDetails: null,
    gymTargetDetails: null,
    ptMembersDatewise: null,
    staffTargets: null,

    subsTypeSales: null,
    subsTypeSalesLoading: false,
    subsTypeSalesError: null,

    biomaxStats: null,
    biomaxStatsLoading: false,
    biomaxStatsError: null,

    totalCheckins: null,
    totalCheckinsLoading: false,
    totalCheckinsError: null,

    trainerMembers: null,
    defaultTrainers: null,
    ctoCategories: null,
    ctoHeads: null,
    ctoStats: null,

    trainerReportsStats: null,
    trainerReportsStatsLoading: false,
    trainerReportsStatsError: null,

    gtptReports: null,
    gtptReportsLoading: false,
    gtptReportsError: null,

    memberLogs: null,
    dailyTargetStatsData: null,
    dailyTargetData: null,
    allCampaigns: null,
    allJobsState: null,
    allJobs: null,

    activePtExpiredSubStats: null,
    activePtExpiredSubStatsLoading: false,
    activePtExpiredSubStatsError: null,

    activePtExpiredSub: null,
    leaveCategories: null,
    staffLeaves: null,
    staffLeaveStats: null,
    staffLeaveYearStats: null,
    gtptTrainerStats: null,
    attendanceChart: null,
    attendanceChart2: null,
    trainerAttendance: null,
    receptionistAttendance: null,
    trainerAssignedMembers: null,
    trainerNotAssignedMembers: null,
    approvalManager: null,
    leadValuesConverted: null,
    rawLeadData: null,
    gymwisePtStats: null,
    allAgents: null,
    ptPartialAmount: null,
    ureCalendarViewData: null,
    subsPartialPending: null,
    subsPartialStats: null,
    ureDetails: null,
    customerIntentCategory: null,
    followupStatuses: null,
    ptTrainerPerformance: null,
    unassignedLeads: null,
    rawLeadStats: null,
    requestedCupons: null,
    ureStat: null,
    centralisedOffers: null,
    cartPendingPayments: null,
    allPTStatsSales: null,
    trainer_member_engagement: null,
    staff_atttendance_report: null,
    one_day_memberships: null,
    abandonedCartData: null,

    ptTrialStatsLoading: false,
    gymAttendanceDetLoading: false,
    tssrsLoading: false,
    tmtaLoading: false,
    tmtaLoading2: false,
    salesLoading: false,
    dietPlanLoading: false,
    ptReportsLoading: false,
    loadingDTM: false,
    loading: false,
    error: null,
    ptReportError: null,
    trainerAttendanceLoading: false,
    receptionistAttendanceLoading: false,
    trainerAssignedMembersLoading: false,
    trainerNotAssignedMembersLoading: false,

    leadStatsLoading: false,
    leadStats: null,
    leadStatsError: null,

    allLeadsLoading: false,
    allLeads: null,
    allLeadsError: null,

    leadValuesConvertedLoading: false,
    gymwisePtStatsLoading: false,
    allAgentsLoading: false,
    ptPartialLoading: false,
    subsPartialPendingLoading: false,
    ureDetailsLoading: false,
    followupStatusLoading: false,
    rawLeadLoading: false,
    ptTrainerPerformanceLoading: false,
    unassignedLeadsLoading: false,
    rawLeadStatsLoading: false,
    cartPendingPaymentsLoading: false,
    allPTStatsSalesLoading: false,
    tmeLoading: false,

    tmeActiveUsers: null,
    tmeActiveUsersLoading: false,
    tmeActiveUsersError: null,

    staff_atttendance_loading: false,
    loadingGTPTTrainers: false,
    one_day_memberships_loading: false,
    abandonedCartDataLoading: false,
    approvalManagerLoading: false,
    staffLeavesLoading: false,

    dateWiseAgentData: null,
    AgentWiseData: null,
    AgentReportTaskSopData: null,
    TVData: null,
    TVStakeHolderData: null,

    agreementReport: null,
    closureReport: null,
    closureReportList: null,

    tmeStats: null,
    tmeStatsLoading: false,
    tmeStatsError: null,

    tmeActiveUserStats: null,
    tmeActiveUserStatsLoading: false,
    tmeActiveUserStatsError: null,

    tmeExpiredMembersStats: null,
    tmeExpiredMembersStatsLoading: false,
    tmeExpiredMembersStatsError: null,

    tmeExpiredMembers: null,
    tmeExpiredMembersLoading: false,
    tmeExpiredMembersError: null,

    trainerData: null,

    odmAll: null,
    odmAllLoading: false,
    odmAllError: null,

    gymWiseODM: null,
    gymWiseODMLoading: false,
    gymWiseODMError: null,

    timeSheetData: null,
    sheetContentData: null,

    versionData: null,
    galleryData: null,

    centralizedBenefitsData: null,
    notificationData: null,

    ptRevenueToday: null,
    ptRevenueTodayLoading: false,
    ptRevenueTodayError: null,

    lateCheckinsReportData: null,
    lateCheckinsReportDataLoading: false,
    lateCheckinsReportDataError: null,

    lateCheckinsStatsData: null,
    lateCheckinsStatsDataLoading: false,
    lateCheckinsStatsDataError: null,

    ticketsLoading: false,
    ticketsError: null,
    ticketsData: [],
    ticketsPagination: [],
    ticketStats: null,
    ticketStatsLoading: false,
    ticketStatsError: null,
    ticketTat: null,
    ticketTatLoading: false,
    ticketTatError: null,

    untrackedWatiLeads: null,
    untrackedWatiLeadsLoading: false,
    untrackedWatiLeadsError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // TV Monitoring Dashboard
      .addCase(fetchTvMonitoringDashboardData.pending, (state) => {
        state.tvMonitoringDashboardLoading = true;
        state.tvMonitoringDashboardError = null;
      })
      .addCase(fetchTvMonitoringDashboardData.fulfilled, (state, action) => {
        state.tvMonitoringDashboardLoading = false;
        state.tvMonitoringDashboard = action.payload;
      })
      .addCase(fetchTvMonitoringDashboardData.rejected, (state, action) => {
        state.tvMonitoringDashboardLoading = false;
        state.tvMonitoringDashboardError = action.error.message;
      })
      .addCase(fetchTvMonitoringGymStatsData.pending, (state) => {
        state.tvMonitoringGymStatsLoading = true;
      })
      .addCase(fetchTvMonitoringGymStatsData.fulfilled, (state, action) => {
        state.tvMonitoringGymStatsLoading = false;
        state.tvMonitoringGymStats = action.payload;
      })
      .addCase(fetchTvMonitoringGymStatsData.rejected, (state) => {
        state.tvMonitoringGymStatsLoading = false;
      })
      .addCase(fetchSettlementData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSettlementData.fulfilled, (state, action) => {
        state.loading = false;
        state.settlementData = action.payload;
      })
      .addCase(fetchSettlementData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchCTOHead.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCTOHead.fulfilled, (state, action) => {
        state.loading = false;
        state.ctoHeadData = action.payload;
      })
      .addCase(fetchCTOHead.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchCTOData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCTOData.fulfilled, (state, action) => {
        state.loading = false;
        state.ctoData = action.payload;
      })
      .addCase(fetchCTOData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchCreateNewSettlementData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCreateNewSettlementData.fulfilled, (state, action) => {
        state.loading = false;
        state.searchedSettlementData = action.payload;
      })
      .addCase(fetchCreateNewSettlementData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchProfitShareData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchProfitShareData.fulfilled, (state, action) => {
        state.loading = false;
        state.profitShareData = action.payload;
      })
      .addCase(fetchProfitShareData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(createNewSettlementInitiateData.pending, (state) => {
        state.loading = true;
      })
      .addCase(createNewSettlementInitiateData.fulfilled, (state, action) => {
        state.loading = false;
        state.initiateData = action.payload;
      })
      .addCase(createNewSettlementInitiateData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchAllGymsData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllGymsData.fulfilled, (state, action) => {
        state.loading = false;
        state.allGymsGstIncludedData = action.payload;
      })
      .addCase(fetchAllGymsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchAllSettlementCardsData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllSettlementCardsData.fulfilled, (state, action) => {
        state.loading = false;
        state.settlementCardData = action.payload;
      })
      .addCase(fetchAllSettlementCardsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchAllSettlementChartsData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllSettlementChartsData.fulfilled, (state, action) => {
        state.loading = false;
        state.settlementChartsData = action.payload;
      })
      .addCase(fetchAllSettlementChartsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchAllRenewalStatsData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllRenewalStatsData.fulfilled, (state, action) => {
        state.loading = false;
        state.renewalsStatsData = action.payload;
      })
      .addCase(fetchAllRenewalStatsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchAllRenewalTableData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllRenewalTableData.fulfilled, (state, action) => {
        state.loading = false;
        state.renewalTableData = action.payload;
      })
      .addCase(fetchAllRenewalTableData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchAllPastDiscussionsData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllPastDiscussionsData.fulfilled, (state, action) => {
        state.loading = false;
        state.pastDiscussionsData = action.payload;
      })
      .addCase(fetchAllPastDiscussionsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchAllPastDiscussionLogsData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllPastDiscussionLogsData.fulfilled, (state, action) => {
        state.loading = false;
        state.discussionLogsData = action.payload;
      })
      .addCase(fetchAllPastDiscussionLogsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchAllRecentRenewalData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllRecentRenewalData.fulfilled, (state, action) => {
        state.loading = false;
        state.recentRenewalData = action.payload;
      })
      .addCase(fetchAllRecentRenewalData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchAllAddonsByGymData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllAddonsByGymData.fulfilled, (state, action) => {
        state.loading = false;
        state.allAddonsByGymData = action.payload;
      })
      .addCase(fetchAllAddonsByGymData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchAllAddonSessionsData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllAddonSessionsData.fulfilled, (state, action) => {
        state.loading = false;
        state.allAddonSessions = action.payload;
      })
      .addCase(fetchAllAddonSessionsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchAllAddonSlotsData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllAddonSlotsData.fulfilled, (state, action) => {
        state.loading = false;
        state.allAddonSlots = action.payload;
      })
      .addCase(fetchAllAddonSlotsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchAllIncentivesData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllIncentivesData.fulfilled, (state, action) => {
        state.loading = false;
        state.allIncentivesData = action.payload;
      })
      .addCase(fetchAllIncentivesData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchAllOffersByTypeIdData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllOffersByTypeIdData.fulfilled, (state, action) => {
        state.loading = false;
        state.allOffersByTypeIdData = action.payload;
      })
      .addCase(fetchAllOffersByTypeIdData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(checkOfferValidityByUserData.pending, (state) => {
        state.loading = true;
      })
      .addCase(checkOfferValidityByUserData.fulfilled, (state, action) => {
        state.loading = false;
        state.offerValidityCheckByUser = action.payload;
      })
      .addCase(checkOfferValidityByUserData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(checkOfferValidationByCodeData.pending, (state) => {
        state.loading = true;
      })
      .addCase(checkOfferValidationByCodeData.fulfilled, (state, action) => {
        state.loading = false;
        state.offerValidityCheckByUser = action.payload;
      })
      .addCase(checkOfferValidationByCodeData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchAllRenewalStatsAllData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllRenewalStatsAllData.fulfilled, (state, action) => {
        state.loading = false;
        state.renewalsStatsAllData = action.payload;
      })
      .addCase(fetchAllRenewalStatsAllData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchAllRenewalTableAllData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllRenewalTableAllData.fulfilled, (state, action) => {
        state.loading = false;
        state.renewalTableAllData = action.payload;
      })
      .addCase(fetchAllRenewalTableAllData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchAllOnlinePaymentLinksData.pending, (state) => {
        state.allOnlinePaymentLinkDataLoading = true;
        state.allOnlinePaymentLinkDataError = null;
      })
      .addCase(fetchAllOnlinePaymentLinksData.fulfilled, (state, action) => {
        state.allOnlinePaymentLinkDataLoading = false;
        state.allOnlinePaymentLinkData = action.payload;
      })
      .addCase(fetchAllOnlinePaymentLinksData.rejected, (state, action) => {
        state.allOnlinePaymentLinkDataLoading = false;
        state.allOnlinePaymentLinkDataError = action.error.message;
      })

      .addCase(fetchAllCashPaymentLinksData.pending, (state) => {
        state.allCashPaymentDataLoading = true;
        state.allCashPaymentDataError = null;
      })
      .addCase(fetchAllCashPaymentLinksData.fulfilled, (state, action) => {
        state.allCashPaymentDataLoading = false;
        state.allCashPaymentData = action.payload;
      })
      .addCase(fetchAllCashPaymentLinksData.rejected, (state, action) => {
        state.allCashPaymentDataLoading = false;
        state.allCashPaymentDataError = action.error.message;
      })

      .addCase(fetchUserDetailsByMobileData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchUserDetailsByMobileData.fulfilled, (state, action) => {
        state.loading = false;
        state.userDetailsByMobile = action.payload;
      })
      .addCase(fetchUserDetailsByMobileData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchAllTrainersByExpLvlData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllTrainersByExpLvlData.fulfilled, (state, action) => {
        state.loading = false;
        state.allTrainerByExpLvlData = action.payload;
      })
      .addCase(fetchAllTrainersByExpLvlData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchAllTrainersSlotsData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllTrainersSlotsData.fulfilled, (state, action) => {
        state.loading = false;
        state.trainerSlotDetails = action.payload;
      })
      .addCase(fetchAllTrainersSlotsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchAllSalesReportByFilterTypeData.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        fetchAllSalesReportByFilterTypeData.fulfilled,
        (state, action) => {
          state.loading = false;
          state.salesReportsBuFiltertypeData = action.payload;
        }
      )
      .addCase(
        fetchAllSalesReportByFilterTypeData.rejected,
        (state, action) => {
          state.loading = false;
          state.error = action.error.message;
        }
      )

      .addCase(fetchAllRenewalsData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllRenewalsData.fulfilled, (state, action) => {
        state.loading = false;
        state.allRenewalsData = action.payload;
      })
      .addCase(fetchAllRenewalsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchAllFeedbacksData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllFeedbacksData.fulfilled, (state, action) => {
        state.loading = false;
        state.allFeedbacksData = action.payload;
      })
      .addCase(fetchAllFeedbacksData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchAllPTStatsData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllPTStatsData.fulfilled, (state, action) => {
        state.loading = false;
        state.allPTStatsData = action.payload;
      })
      .addCase(fetchAllPTStatsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchExpiringPTStatsData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchExpiringPTStatsData.fulfilled, (state, action) => {
        state.loading = false;
        state.expiringPTStatsData = action.payload;
      })
      .addCase(fetchExpiringPTStatsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchPlansPTStatsData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPlansPTStatsData.fulfilled, (state, action) => {
        state.loading = false;
        state.plansPTStatsData = action.payload;
      })
      .addCase(fetchPlansPTStatsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchPTChartsData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPTChartsData.fulfilled, (state, action) => {
        state.loading = false;
        state.ptChartsData = action.payload;
      })
      .addCase(fetchPTChartsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchTodayPTData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTodayPTData.fulfilled, (state, action) => {
        state.loading = false;
        state.todayPT = action.payload;
      })
      .addCase(fetchTodayPTData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchUpcomingPTData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchUpcomingPTData.fulfilled, (state, action) => {
        state.loading = false;
        state.upcomingPTData = action.payload;
      })
      .addCase(fetchUpcomingPTData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchAllPTMembersData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllPTMembersData.fulfilled, (state, action) => {
        state.loading = false;
        state.ptMembersData = action.payload;
      })
      .addCase(fetchAllPTMembersData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchPTTrainersData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPTTrainersData.fulfilled, (state, action) => {
        state.loading = false;
        state.allPTTrainersData = action.payload;
      })
      .addCase(fetchPTTrainersData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchAllPTPlansData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllPTPlansData.fulfilled, (state, action) => {
        state.loading = false;
        state.allPTPlansData = action.payload;
      })
      .addCase(fetchAllPTPlansData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchTopTrainersData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTopTrainersData.fulfilled, (state, action) => {
        state.loading = false;
        state.topTrainersData = action.payload;
      })
      .addCase(fetchTopTrainersData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchTrainersOccupancyData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTrainersOccupancyData.fulfilled, (state, action) => {
        state.loading = false;
        state.trainerOccupancyData = action.payload;
      })
      .addCase(fetchTrainersOccupancyData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchTrainersMonthlyTagetData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTrainersMonthlyTagetData.fulfilled, (state, action) => {
        state.loading = false;
        state.trainersMonthlyTargetData = action.payload;
      })
      .addCase(fetchTrainersMonthlyTagetData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchTrainersTotalMembersData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTrainersTotalMembersData.fulfilled, (state, action) => {
        state.loading = false;
        state.trainersTotalMembersData = action.payload;
      })
      .addCase(fetchTrainersTotalMembersData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchLastSalesData.pending, (state) => {
        state.salesLoading = true;
        state.error = null;
      })
      .addCase(fetchLastSalesData.fulfilled, (state, action) => {
        state.salesLoading = false;
        state.lastSalesData = action.payload;
      })
      .addCase(fetchLastSalesData.rejected, (state, action) => {
        state.salesLoading = false;
        state.error = action.error.message;
      })

      .addCase(fetchTrainerRatingsData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTrainerRatingsData.fulfilled, (state, action) => {
        state.loading = false;
        state.trainerRatingsData = action.payload;
      })
      .addCase(fetchTrainerRatingsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchAssignedMembersData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAssignedMembersData.fulfilled, (state, action) => {
        state.loading = false;
        state.assignedMembersData = action.payload;
      })
      .addCase(fetchAssignedMembersData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchTMTAData.pending, (state) => {
        state.tmtaLoading = true;
        state.error = null;
      })
      .addCase(fetchTMTAData.fulfilled, (state, action) => {
        state.tmtaLoading = false;
        state.tmtaData = action.payload;
      })
      .addCase(fetchTMTAData.rejected, (state, action) => {
        state.tmtaLoading = false;
        state.error = action.error.message;
      })

      .addCase(fetchTMTAData2.pending, (state) => {
        state.tmtaLoading2 = true;
        state.error = null;
      })
      .addCase(fetchTMTAData2.fulfilled, (state, action) => {
        state.tmtaLoading2 = false;
        state.tmtaData2 = action.payload;
      })
      .addCase(fetchTMTAData2.rejected, (state, action) => {
        state.tmtaLoading2 = false;
        state.error = action.error.message;
      })

      .addCase(fetchMissedPTData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMissedPTData.fulfilled, (state, action) => {
        state.loading = false;
        state.missedPTData = action.payload;
      })
      .addCase(fetchMissedPTData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchAllTrainersData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllTrainersData.fulfilled, (state, action) => {
        state.loading = false;
        state.allTrainersData = action.payload;
      })
      .addCase(fetchAllTrainersData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchTSARData.pending, (state) => {
        state.tssrsLoading = true;
      })
      .addCase(fetchTSARData.fulfilled, (state, action) => {
        state.tssrsLoading = false;
        state.tsarData = action.payload;
      })
      .addCase(fetchTSARData.rejected, (state, action) => {
        state.tssrsLoading = false;
        state.error = action.error.message;
      })

      .addCase(fetchTargetAchievedData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTargetAchievedData.fulfilled, (state, action) => {
        state.loading = false;
        state.achievedTargetData = action.payload;
      })
      .addCase(fetchTargetAchievedData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchTargetAchievedData1.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTargetAchievedData1.fulfilled, (state, action) => {
        state.loading = false;
        state.achievedTargetData1 = action.payload;
      })
      .addCase(fetchTargetAchievedData1.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchGymsAttendanceData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchGymsAttendanceData.fulfilled, (state, action) => {
        state.loading = false;
        state.allGymAttendanceData = action.payload;
      })
      .addCase(fetchGymsAttendanceData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchGymsAttendanceDetailedData.pending, (state) => {
        state.gymAttendanceDetLoading = true;
      })
      .addCase(fetchGymsAttendanceDetailedData.fulfilled, (state, action) => {
        state.gymAttendanceDetLoading = false;
        state.gymAttendanceDetails = action.payload;
      })
      .addCase(fetchGymsAttendanceDetailedData.rejected, (state, action) => {
        state.gymAttendanceDetLoading = false;
        state.error = action.error.message;
      })

      .addCase(fetchTargetAchievedDetailsData.pending, (state) => {
        state.gymAttendanceDetLoading = true;
      })
      .addCase(fetchTargetAchievedDetailsData.fulfilled, (state, action) => {
        state.gymAttendanceDetLoading = false;
        state.gymTargetDetails = action.payload;
      })
      .addCase(fetchTargetAchievedDetailsData.rejected, (state, action) => {
        state.gymAttendanceDetLoading = false;
        state.error = action.error.message;
      })

      .addCase(fetchAllSubscriptionData.pending, (state) => {
        state.allSubscriptionDataLoading = true;
      })
      .addCase(fetchAllSubscriptionData.fulfilled, (state, action) => {
        state.allSubscriptionDataLoading = false;
        state.allSubscriptionData = action.payload;
      })
      .addCase(fetchAllSubscriptionData.rejected, (state, action) => {
        state.allSubscriptionDataLoading = false;
        state.allSubscriptionDataError = action.error.message;
      })

      .addCase(exportAllSubscriptionData.pending, (state) => {
        state.exportedSubscriptionDataLoading = true;
      })
      .addCase(exportAllSubscriptionData.fulfilled, (state, action) => {
        state.exportedSubscriptionDataLoading = false;
        state.exportedSubscriptionData = action.payload;
      })
      .addCase(exportAllSubscriptionData.rejected, (state, action) => {
        state.exportedSubscriptionDataLoading = false;
        state.exportedSubscriptionDataError = action.error.message;
      })

      .addCase(fetchAllUnmappedUserData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllUnmappedUserData.fulfilled, (state, action) => {
        state.loading = false;
        state.unmappedUserData = action.payload;
      })
      .addCase(fetchAllUnmappedUserData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchPartialPaymentsData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPartialPaymentsData.fulfilled, (state, action) => {
        state.loading = false;
        state.partialPaymentsData = action.payload;
      })
      .addCase(fetchPartialPaymentsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchAllMealsData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllMealsData.fulfilled, (state, action) => {
        state.loading = false;
        state.allMealsData = action.payload;
      })
      .addCase(fetchAllMealsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchAllUnitsData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllUnitsData.fulfilled, (state, action) => {
        state.loading = false;
        state.allUnitsData = action.payload;
      })
      .addCase(fetchAllUnitsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchAllWatiLogsData.pending, (state) => {
        state.watilogsLoading = true;
      })
      .addCase(fetchAllWatiLogsData.fulfilled, (state, action) => {
        state.watilogsLoading = false;
        state.watiLogs = action.payload;
      })
      .addCase(fetchAllWatiLogsData.rejected, (state, action) => {
        state.watilogsLoading = false;
        state.error = action.error.message;
      })

      .addCase(fetchAllKeywordsData.pending, (state) => {
        state.keywordLoading = true;
      })
      .addCase(fetchAllKeywordsData.fulfilled, (state, action) => {
        state.keywordLoading = false;
        state.allKeywords = action.payload;
      })
      .addCase(fetchAllKeywordsData.rejected, (state, action) => {
        state.keywordLoading = false;
        state.error = action.error.message;
      })

      .addCase(fetchSheetTabsStatsData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSheetTabsStatsData.fulfilled, (state, action) => {
        state.loading = false;
        state.sheetAndTabs = action.payload;
      })
      .addCase(fetchSheetTabsStatsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(exportAllUsersDataByChoiceData.pending, (state) => {
        state.loading = true;
      })
      .addCase(exportAllUsersDataByChoiceData.fulfilled, (state, action) => {
        state.loading = false;
        state.usersExportedData = action.payload;
      })
      .addCase(exportAllUsersDataByChoiceData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchIngredientsData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchIngredientsData.fulfilled, (state, action) => {
        state.loading = false;
        state.ingData = action.payload;
      })
      .addCase(fetchIngredientsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchDietTimingsData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDietTimingsData.fulfilled, (state, action) => {
        state.loading = false;
        state.dietTimingsData = action.payload;
      })
      .addCase(fetchDietTimingsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchDietTypesData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDietTypesData.fulfilled, (state, action) => {
        state.loading = false;
        state.dietTypesData = action.payload;
      })
      .addCase(fetchDietTypesData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchDietPreferenceData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDietPreferenceData.fulfilled, (state, action) => {
        state.loading = false;
        state.dietPreferenceData = action.payload;
      })
      .addCase(fetchDietPreferenceData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchDieticiansData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDieticiansData.fulfilled, (state, action) => {
        state.loading = false;
        state.dieticiansData = action.payload;
      })
      .addCase(fetchDieticiansData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchPtTracksData.pending, (state) => {
        state.ptTracksDataLoading = true;
      })
      .addCase(fetchPtTracksData.fulfilled, (state, action) => {
        state.ptTracksDataLoading = false;
        state.ptTracksData = action.payload;
      })
      .addCase(fetchPtTracksData.rejected, (state, action) => {
        state.ptTracksDataLoading = false;
        state.ptTracksDataError = action.error.message;
      })

      .addCase(totalSubsGymwiseData.pending, (state) => {
        state.totalSubscriptionGymwiseLoading = true;
      })
      .addCase(totalSubsGymwiseData.fulfilled, (state, action) => {
        state.totalSubscriptionGymwiseLoading = false;
        state.totalSubscriptionGymwise = action.payload;
      })
      .addCase(totalSubsGymwiseData.rejected, (state, action) => {
        state.totalSubscriptionGymwiseLoading = false;
        state.totalSubscriptionGymwiseError = action.error.message;
      })

      .addCase(totalHandoverByMeData.pending, (state) => {
        state.handoverByMeLoading = true;
      })
      .addCase(totalHandoverByMeData.fulfilled, (state, action) => {
        state.handoverByMeLoading = false;
        state.handoverByMe = action.payload;
      })
      .addCase(totalHandoverByMeData.rejected, (state, action) => {
        state.handoverByMeLoading = false;
        state.handoverByMeError = action.error.message;
      })

      .addCase(totalTrialInitiatedByMeData.pending, (state) => {
        state.trialInitiatedByMeLoading = true;
      })
      .addCase(totalTrialInitiatedByMeData.fulfilled, (state, action) => {
        state.trialInitiatedByMeLoading = false;
        state.trialInitiatedByMe = action.payload;
      })
      .addCase(totalTrialInitiatedByMeData.rejected, (state, action) => {
        state.trialInitiatedByMeLoading = false;
        state.trialInitiatedByMeError = action.error.message;
      })

      .addCase(fetchPtTracksDataCheck.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPtTracksDataCheck.fulfilled, (state, action) => {
        state.loading = false;
        state.ptTracksDataCheck = action.payload;
      })
      .addCase(fetchPtTracksDataCheck.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchPTTrialStatsData.pending, (state) => {
        state.ptTrialStatsLoading = true;
      })
      .addCase(fetchPTTrialStatsData.fulfilled, (state, action) => {
        state.ptTrialStatsLoading = false;
        state.ptTrialStatsData = action.payload;
      })
      .addCase(fetchPTTrialStatsData.rejected, (state, action) => {
        state.ptTrialStatsLoading = false;
        state.error = action.error.message;
      })

      .addCase(fetchAllReceptionistsData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllReceptionistsData.fulfilled, (state, action) => {
        state.loading = false;
        state.allRecepData = action.payload;
      })
      .addCase(fetchAllReceptionistsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchExpertiseData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchExpertiseData.fulfilled, (state, action) => {
        state.loading = false;
        state.expertiseData = action.payload;
      })
      .addCase(fetchExpertiseData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchDietStatsData.pending, (state) => {
        state.dietPlanLoading = true;
      })
      .addCase(fetchDietStatsData.fulfilled, (state, action) => {
        state.dietPlanLoading = false;
        state.dietStatsData = action.payload;
      })
      .addCase(fetchDietStatsData.rejected, (state, action) => {
        state.dietPlanLoading = false;
        state.error = action.error.message;
      })

      .addCase(fetchDietCardsData.pending, (state) => {
        state.dietPlanLoading = true;
        state.error = false;
      })
      .addCase(fetchDietCardsData.fulfilled, (state, action) => {
        state.dietPlanLoading = false;
        state.dietCardsData = action.payload;
      })
      .addCase(fetchDietCardsData.rejected, (state, action) => {
        state.dietPlanLoading = false;
        state.error = action.error.message;
      })

      .addCase(fetchAllDietPlanData.pending, (state) => {
        state.dietPlanLoading = true;
        state.error = false;
      })
      .addCase(fetchAllDietPlanData.fulfilled, (state, action) => {
        state.dietPlanLoading = false;
        state.dietPlansData = action.payload;
      })
      .addCase(fetchAllDietPlanData.rejected, (state, action) => {
        state.dietPlanLoading = false;
        state.error = action.error.message;
      })

      .addCase(fetchAllDietPackagesData.pending, (state) => {
        state.loading = true;
        state.error = false;
      })
      .addCase(fetchAllDietPackagesData.fulfilled, (state, action) => {
        state.loading = false;
        state.dietPackagesData = action.payload;
      })
      .addCase(fetchAllDietPackagesData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchFreeDietPackagesData.pending, (state) => {
        state.loading = true;
        state.error = false;
      })
      .addCase(fetchFreeDietPackagesData.fulfilled, (state, action) => {
        state.loading = false;
        state.freeDietPackages = action.payload;
      })
      .addCase(fetchFreeDietPackagesData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchPaidDietPackagesData.pending, (state) => {
        state.loading = true;
        state.error = false;
      })
      .addCase(fetchPaidDietPackagesData.fulfilled, (state, action) => {
        state.loading = false;
        state.paidDietPackages = action.payload;
      })
      .addCase(fetchPaidDietPackagesData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchPTReportsData.pending, (state) => {
        state.ptReportsLoading = true;
        state.ptReportError = false;
      })
      .addCase(fetchPTReportsData.fulfilled, (state, action) => {
        state.ptReportsLoading = false;
        state.ptReportsData = action.payload;
      })
      .addCase(fetchPTReportsData.rejected, (state, action) => {
        state.ptReportsLoading = false;
        state.ptReportError = action.error.message;
      })

      .addCase(fetchMembersByIdData.pending, (state) => {
        state.loading = true;
        state.error = false;
      })
      .addCase(fetchMembersByIdData.fulfilled, (state, action) => {
        state.loading = false;
        state.memberById = action.payload;
      })
      .addCase(fetchMembersByIdData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchPTMemberDatewiseData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPTMemberDatewiseData.fulfilled, (state, action) => {
        state.loading = false;
        state.ptMembersDatewise = action.payload;
      })
      .addCase(fetchPTMemberDatewiseData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchStaffTargetsData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStaffTargetsData.fulfilled, (state, action) => {
        state.loading = false;
        state.staffTargets = action.payload;
      })
      .addCase(fetchStaffTargetsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchSubsTypeSalesData.pending, (state) => {
        state.subsTypeSalesLoading = true;
        state.subsTypeSalesError = null;
      })
      .addCase(fetchSubsTypeSalesData.fulfilled, (state, action) => {
        state.subsTypeSalesLoading = false;
        state.subsTypeSales = action.payload;
      })
      .addCase(fetchSubsTypeSalesData.rejected, (state, action) => {
        state.subsTypeSalesLoading = false;
        state.subsTypeSalesError = action.error.message;
      })

      .addCase(fetchBiomaxMemberStatsData.pending, (state) => {
        state.biomaxStatsLoading = true;
        state.biomaxStatsError = null;
      })
      .addCase(fetchBiomaxMemberStatsData.fulfilled, (state, action) => {
        state.biomaxStatsLoading = false;
        state.biomaxStats = action.payload;
      })
      .addCase(fetchBiomaxMemberStatsData.rejected, (state, action) => {
        state.biomaxStatsLoading = false;
        state.biomaxStatsError = action.error.message;
      })

      .addCase(fetchTotalCheckinsData.pending, (state) => {
        state.totalCheckinsLoading = true;
        state.totalCheckinsError = null;
      })
      .addCase(fetchTotalCheckinsData.fulfilled, (state, action) => {
        state.totalCheckinsLoading = false;
        state.totalCheckins = action.payload;
      })
      .addCase(fetchTotalCheckinsData.rejected, (state, action) => {
        state.totalCheckinsLoading = false;
        state.totalCheckinsError = action.error.message;
      })

      .addCase(fetchDefaultTrainersData.pending, (state) => {
        state.loadingDTM = true;
        state.error = null;
      })
      .addCase(fetchDefaultTrainersData.fulfilled, (state, action) => {
        state.loadingDTM = false;
        state.defaultTrainers = action.payload;
      })
      .addCase(fetchDefaultTrainersData.rejected, (state, action) => {
        state.loadingDTM = false;
        state.error = action.error.message;
      })

      .addCase(fetchGTPTreportsDetails.pending, (state) => {
        state.loadingDTM = true;
        state.error = null;
      })
      .addCase(fetchGTPTreportsDetails.fulfilled, (state, action) => {
        state.loadingDTM = false;
        state.defaultTrainers = action.payload;
      })
      .addCase(fetchGTPTreportsDetails.rejected, (state, action) => {
        state.loadingDTM = false;
        state.error = action.error.message;
      })

      .addCase(fetchTrainerMembersData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTrainerMembersData.fulfilled, (state, action) => {
        state.loading = false;
        state.trainerMembers = action.payload;
      })
      .addCase(fetchTrainerMembersData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchCtoCategoriesData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCtoCategoriesData.fulfilled, (state, action) => {
        state.loading = false;
        state.ctoCategories = action.payload;
      })
      .addCase(fetchCtoCategoriesData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchCtoHeadsData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCtoHeadsData.fulfilled, (state, action) => {
        state.loading = false;
        state.ctoHeads = action.payload;
      })
      .addCase(fetchCtoHeadsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchCtoStatsData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCtoStatsData.fulfilled, (state, action) => {
        state.loading = false;
        state.ctoStats = action.payload;
      })
      .addCase(fetchCtoStatsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchTrainerReportsStatsData.pending, (state) => {
        state.trainerReportsStatsLoading = true;
        state.trainerReportsStatsError = null;
      })
      .addCase(fetchTrainerReportsStatsData.fulfilled, (state, action) => {
        state.trainerReportsStatsLoading = false;
        state.trainerReportsStats = action.payload;
      })
      .addCase(fetchTrainerReportsStatsData.rejected, (state, action) => {
        state.trainerReportsStatsLoading = false;
        state.trainerReportsStatsError = action.error.message;
      })

      .addCase(fetchGTPTreportsStats.pending, (state) => {
        state.gtptReportsLoading = true;
        state.gtptReportsError = null;
      })
      .addCase(fetchGTPTreportsStats.fulfilled, (state, action) => {
        state.gtptReportsLoading = false;
        state.gtptReports = action.payload;
      })
      .addCase(fetchGTPTreportsStats.rejected, (state, action) => {
        state.gtptReportsLoading = false;
        state.gtptReportsError = action.error.message;
      })

      .addCase(fetchMemberLogsData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMemberLogsData.fulfilled, (state, action) => {
        state.loading = false;
        state.memberLogs = action.payload;
      })
      .addCase(fetchMemberLogsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchDailyTargetStatsData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDailyTargetStatsData.fulfilled, (state, action) => {
        state.loading = false;
        state.dailyTargetStatsData = action.payload;
      })
      .addCase(fetchDailyTargetStatsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchDailyTargetData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDailyTargetData.fulfilled, (state, action) => {
        state.loading = false;
        state.dailyTargetData = action.payload;
      })
      .addCase(fetchDailyTargetData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchAllCampaignsData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllCampaignsData.fulfilled, (state, action) => {
        state.loading = false;
        state.allCampaigns = action.payload;
      })
      .addCase(fetchAllCampaignsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchAllJobsState.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllJobsState.fulfilled, (state, action) => {
        state.loading = false;
        state.allJobsState = action.payload;
      })
      .addCase(fetchAllJobsState.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchAllJobsData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllJobsData.fulfilled, (state, action) => {
        state.loading = false;
        state.allJobs = action.payload;
      })
      .addCase(fetchAllJobsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchActivePtWithExpiredSubStats.pending, (state) => {
        state.activePtExpiredSubStatsLoading = true;
        state.activePtExpiredSubStatsError = null;
      })
      .addCase(fetchActivePtWithExpiredSubStats.fulfilled, (state, action) => {
        state.activePtExpiredSubStatsLoading = false;
        state.activePtExpiredSubStats = action.payload;
      })
      .addCase(fetchActivePtWithExpiredSubStats.rejected, (state, action) => {
        state.activePtExpiredSubStatsLoading = false;
        state.activePtExpiredSubStatsError = action.error.message;
      })

      .addCase(fetchActivePtWithExpiredSubData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchActivePtWithExpiredSubData.fulfilled, (state, action) => {
        state.loading = false;
        state.activePtExpiredSub = action.payload;
      })
      .addCase(fetchActivePtWithExpiredSubData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchLeaveCategoriesData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLeaveCategoriesData.fulfilled, (state, action) => {
        state.loading = false;
        state.leaveCategories = action.payload;
      })
      .addCase(fetchLeaveCategoriesData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchStaffLeavesData.pending, (state) => {
        state.staffLeavesLoading = true;
        state.error = null;
      })
      .addCase(fetchStaffLeavesData.fulfilled, (state, action) => {
        state.staffLeavesLoading = false;
        state.staffLeaves = action.payload;
      })
      .addCase(fetchStaffLeavesData.rejected, (state, action) => {
        state.staffLeavesLoading = false;
        state.error = action.error.message;
      })

      .addCase(fetchStaffLeaveStatsData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStaffLeaveStatsData.fulfilled, (state, action) => {
        state.loading = false;
        state.staffLeaveStats = action.payload;
      })
      .addCase(fetchStaffLeaveStatsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchStaffLeaveYearStats.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStaffLeaveYearStats.fulfilled, (state, action) => {
        state.loading = false;
        state.staffLeaveYearStats = action.payload;
      })
      .addCase(fetchStaffLeaveYearStats.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchGTPTtrainersStats.pending, (state) => {
        state.loadingGTPTTrainers = true;
        state.error = null;
      })
      .addCase(fetchGTPTtrainersStats.fulfilled, (state, action) => {
        state.loadingGTPTTrainers = false;
        state.gtptTrainerStats = action.payload;
      })
      .addCase(fetchGTPTtrainersStats.rejected, (state, action) => {
        state.loadingGTPTTrainers = false;
        state.error = action.error.message;
      })

      .addCase(fetchAttendanceChartData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAttendanceChartData.fulfilled, (state, action) => {
        state.loading = false;
        state.attendanceChart = action.payload;
      })
      .addCase(fetchAttendanceChartData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchAttendanceChartData2.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAttendanceChartData2.fulfilled, (state, action) => {
        state.loading = false;
        state.attendanceChart2 = action.payload;
      })
      .addCase(fetchAttendanceChartData2.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchTrainerAttendanceData.pending, (state) => {
        state.trainerAttendanceLoading = true;
        state.error = null;
      })
      .addCase(fetchTrainerAttendanceData.fulfilled, (state, action) => {
        state.trainerAttendanceLoading = false;
        state.trainerAttendance = action.payload;
      })
      .addCase(fetchTrainerAttendanceData.rejected, (state, action) => {
        state.trainerAttendanceLoading = false;
        state.error = action.error.message;
      })

      .addCase(fetchReceptionistAttendance.pending, (state) => {
        state.receptionistAttendanceLoading = true;
        state.error = null;
      })
      .addCase(fetchReceptionistAttendance.fulfilled, (state, action) => {
        state.receptionistAttendanceLoading = false;
        state.receptionistAttendance = action.payload;
      })
      .addCase(fetchReceptionistAttendance.rejected, (state, action) => {
        state.receptionistAttendanceLoading = false;
        state.error = action.error.message;
      })

      .addCase(fetchTrainerAssignedMembersData.pending, (state) => {
        state.trainerAssignedMembersLoading = true;
        state.error = null;
      })
      .addCase(fetchTrainerAssignedMembersData.fulfilled, (state, action) => {
        state.trainerAssignedMembersLoading = false;
        state.trainerAssignedMembers = action.payload;
      })
      .addCase(fetchTrainerAssignedMembersData.rejected, (state, action) => {
        state.trainerAssignedMembersLoading = false;
        state.error = action.error.message;
      })

      .addCase(fetchTrainerNotAssignedMembersData.pending, (state) => {
        state.trainerNotAssignedMembersLoading = true;
        state.error = null;
      })
      .addCase(
        fetchTrainerNotAssignedMembersData.fulfilled,
        (state, action) => {
          state.trainerNotAssignedMembersLoading = false;
          state.trainerNotAssignedMembers = action.payload;
        }
      )
      .addCase(fetchTrainerNotAssignedMembersData.rejected, (state, action) => {
        state.trainerNotAssignedMembersLoading = false;
        state.error = action.error.message;
      })

      .addCase(fetchApprovalManagerData.pending, (state) => {
        state.approvalManagerLoading = true;
        state.error = null;
      })
      .addCase(fetchApprovalManagerData.fulfilled, (state, action) => {
        state.approvalManagerLoading = false;
        state.approvalManager = action.payload;
      })
      .addCase(fetchApprovalManagerData.rejected, (state, action) => {
        state.approvalManagerLoading = false;
        state.error = action.error.message;
      })

      .addCase(fetchLeadsStatsData.pending, (state) => {
        state.leadStatsLoading = true;
        state.leadStatsError = null;
      })
      .addCase(fetchLeadsStatsData.fulfilled, (state, action) => {
        state.leadStatsLoading = false;
        state.leadStats = action.payload;
      })
      .addCase(fetchLeadsStatsData.rejected, (state, action) => {
        state.leadStatsLoading = false;
        state.leadStatsError = action.error.message;
      })

      .addCase(fetchAllLeadsData.pending, (state) => {
        state.allLeadsLoading = true;
        state.allLeadsError = null;
      })
      .addCase(fetchAllLeadsData.fulfilled, (state, action) => {
        state.allLeadsLoading = false;
        state.allLeads = action.payload;
      })
      .addCase(fetchAllLeadsData.rejected, (state, action) => {
        state.allLeadsLoading = false;
        state.allLeadsError = action.error.message;
      })

      .addCase(fetchLeadValuesConvertedData.pending, (state) => {
        state.leadValuesConvertedLoading = true;
        state.error = null;
      })
      .addCase(fetchLeadValuesConvertedData.fulfilled, (state, action) => {
        state.leadValuesConvertedLoading = false;
        state.leadValuesConverted = action.payload;
      })
      .addCase(fetchLeadValuesConvertedData.rejected, (state, action) => {
        state.leadValuesConvertedLoading = false;
        state.error = action.error.message;
      })

      .addCase(fetchRawLeadsData.pending, (state) => {
        state.rawLeadLoading = true;
        state.error = null;
      })
      .addCase(fetchRawLeadsData.fulfilled, (state, action) => {
        state.rawLeadLoading = false;
        state.rawLeadData = action.payload;
      })
      .addCase(fetchRawLeadsData.rejected, (state, action) => {
        state.rawLeadLoading = false;
        state.error = action.error.message;
      })

      .addCase(fetchAllGymwisePTStatsData.pending, (state) => {
        state.gymwisePtStatsLoading = true;
        state.error = null;
      })
      .addCase(fetchAllGymwisePTStatsData.fulfilled, (state, action) => {
        state.gymwisePtStatsLoading = false;
        state.gymwisePtStats = action.payload;
      })
      .addCase(fetchAllGymwisePTStatsData.rejected, (state, action) => {
        state.gymwisePtStatsLoading = false;
        state.error = action.error.message;
      })

      .addCase(fetchAllAgentsData.pending, (state) => {
        state.allAgentsLoading = true;
        state.error = null;
      })
      .addCase(fetchAllAgentsData.fulfilled, (state, action) => {
        state.allAgentsLoading = false;
        state.allAgents = action.payload;
      })
      .addCase(fetchAllAgentsData.rejected, (state, action) => {
        state.allAgentsLoading = false;
        state.error = action.error.message;
      })

      .addCase(fetchPTPartialData.pending, (state) => {
        state.ptPartialLoading = true;
        state.error = null;
      })
      .addCase(fetchPTPartialData.fulfilled, (state, action) => {
        state.ptPartialLoading = false;
        state.ptPartialAmount = action.payload;
      })
      .addCase(fetchPTPartialData.rejected, (state, action) => {
        state.ptPartialLoading = false;
        state.error = action.error.message;
      })

      .addCase(fetchURECalendarData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchURECalendarData.fulfilled, (state, action) => {
        state.loading = false;
        state.ureCalendarViewData = action.payload;
      })
      .addCase(fetchURECalendarData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchUREDetailsData.pending, (state) => {
        state.ureDetailsLoading = true;
        state.error = null;
      })
      .addCase(fetchUREDetailsData.fulfilled, (state, action) => {
        state.ureDetailsLoading = false;
        state.ureDetails = action.payload;
      })
      .addCase(fetchUREDetailsData.rejected, (state, action) => {
        state.ureDetailsLoading = false;
        state.error = action.error.message;
      })

      .addCase(fetchSubsPartialPendingData.pending, (state) => {
        state.subsPartialPendingLoading = true;
        state.error = null;
      })
      .addCase(fetchSubsPartialPendingData.fulfilled, (state, action) => {
        state.subsPartialPendingLoading = false;
        state.subsPartialPending = action.payload;
      })
      .addCase(fetchSubsPartialPendingData.rejected, (state, action) => {
        state.subsPartialPendingLoading = false;
        state.error = action.error.message;
      })

      .addCase(fetchSubsPartialStatsData.pending, (state) => {
        state.subsPartialPendingLoading = true;
        state.error = null;
      })
      .addCase(fetchSubsPartialStatsData.fulfilled, (state, action) => {
        state.subsPartialPendingLoading = false;
        state.subsPartialStats = action.payload;
      })
      .addCase(fetchSubsPartialStatsData.rejected, (state, action) => {
        state.subsPartialPendingLoading = false;
        state.error = action.error.message;
      })

      .addCase(fetchFollowupStatusData.pending, (state) => {
        state.followupStatusLoading = true;
        state.error = null;
      })
      .addCase(fetchFollowupStatusData.fulfilled, (state, action) => {
        state.followupStatusLoading = false;
        state.followupStatuses = action.payload;
      })
      .addCase(fetchFollowupStatusData.rejected, (state, action) => {
        state.followupStatusLoading = false;
        state.error = action.error.message;
      })

      .addCase(fetchCustomerIntentData.pending, (state) => {
        state.followupStatusLoading = true;
        state.error = null;
      })
      .addCase(fetchCustomerIntentData.fulfilled, (state, action) => {
        state.followupStatusLoading = false;
        state.customerIntentCategory = action.payload;
      })
      .addCase(fetchCustomerIntentData.rejected, (state, action) => {
        state.followupStatusLoading = false;
        state.error = action.error.message;
      })

      .addCase(fetchPTTrainerPerformanceData.pending, (state) => {
        state.ptTrainerPerformanceLoading = true;
        state.error = null;
      })
      .addCase(fetchPTTrainerPerformanceData.fulfilled, (state, action) => {
        state.ptTrainerPerformanceLoading = false;
        state.ptTrainerPerformance = action.payload;
      })
      .addCase(fetchPTTrainerPerformanceData.rejected, (state, action) => {
        state.ptTrainerPerformanceLoading = false;
        state.error = action.error.message;
      })

      .addCase(fetchUnassignedLeadsData.pending, (state) => {
        state.unassignedLeadsLoading = true;
        state.error = null;
      })
      .addCase(fetchUnassignedLeadsData.fulfilled, (state, action) => {
        state.unassignedLeadsLoading = false;
        state.unassignedLeads = action.payload;
      })
      .addCase(fetchUnassignedLeadsData.rejected, (state, action) => {
        state.unassignedLeadsLoading = false;
        state.error = action.error.message;
      })

      .addCase(fetchRawLeadStatsData.pending, (state) => {
        state.rawLeadStatsLoading = true;
        state.error = null;
      })
      .addCase(fetchRawLeadStatsData.fulfilled, (state, action) => {
        state.rawLeadStatsLoading = false;
        state.rawLeadStats = action.payload;
      })
      .addCase(fetchRawLeadStatsData.rejected, (state, action) => {
        state.rawLeadStatsLoading = false;
        state.error = action.error.message;
      })

      .addCase(fetchRequestedCuponsData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRequestedCuponsData.fulfilled, (state, action) => {
        state.loading = false;
        state.requestedCupons = action.payload;
      })
      .addCase(fetchRequestedCuponsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchUREStatsData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUREStatsData.fulfilled, (state, action) => {
        state.loading = false;
        state.ureStat = action.payload;
      })
      .addCase(fetchUREStatsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchCentralisedOffersData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCentralisedOffersData.fulfilled, (state, action) => {
        state.loading = false;
        state.centralisedOffers = action.payload;
      })
      .addCase(fetchCentralisedOffersData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchCartPendingPaymentsData.pending, (state) => {
        state.cartPendingPaymentsLoading = true;
        state.error = null;
      })
      .addCase(fetchCartPendingPaymentsData.fulfilled, (state, action) => {
        state.cartPendingPaymentsLoading = false;
        state.cartPendingPayments = action.payload;
      })
      .addCase(fetchCartPendingPaymentsData.rejected, (state, action) => {
        state.cartPendingPaymentsLoading = false;
        state.error = action.error.message;
      })

      .addCase(fetchAllPTSalesStatsData.pending, (state) => {
        state.allPTStatsSalesLoading = true;
        state.error = null;
      })
      .addCase(fetchAllPTSalesStatsData.fulfilled, (state, action) => {
        state.allPTStatsSalesLoading = false;
        state.allPTStatsSales = action.payload;
      })
      .addCase(fetchAllPTSalesStatsData.rejected, (state, action) => {
        state.allPTStatsSalesLoading = false;
        state.error = action.error.message;
      })

      .addCase(fetchTMEStatsData.pending, (state) => {
        state.tmeStatsLoading = true;
        state.tmeStatsError = null;
      })
      .addCase(fetchTMEStatsData.fulfilled, (state, action) => {
        state.tmeStatsLoading = false;
        state.tmeStats = action.payload;
      })
      .addCase(fetchTMEStatsData.rejected, (state, action) => {
        state.tmeStatsLoading = false;
        state.tmeStatsError = action.error.message;
      })

      .addCase(fetchTMEActiveUserStatsData.pending, (state) => {
        state.tmeActiveUserStatsLoading = true;
        state.tmeActiveUserStatsError = null;
      })
      .addCase(fetchTMEActiveUserStatsData.fulfilled, (state, action) => {
        state.tmeActiveUserStatsLoading = false;
        state.tmeActiveUserStats = action.payload;
      })
      .addCase(fetchTMEActiveUserStatsData.rejected, (state, action) => {
        state.tmeActiveUserStatsLoading = false;
        state.tmeActiveUserStatsError = action.error.message;
      })

      .addCase(fetchTMEExpiredMembersStatsData.pending, (state) => {
        state.tmeExpiredMembersStatsLoading = true;
        state.tmeExpiredMembersStatsError = null;
      })
      .addCase(fetchTMEExpiredMembersStatsData.fulfilled, (state, action) => {
        state.tmeExpiredMembersStatsLoading = false;
        state.tmeExpiredMembersStats = action.payload;
      })
      .addCase(fetchTMEExpiredMembersStatsData.rejected, (state, action) => {
        state.tmeExpiredMembersStatsLoading = false;
        state.tmeExpiredMembersStatsError = action.error.message;
      })

      .addCase(fetchTMEExpiredMembersData.pending, (state) => {
        state.tmeExpiredMembersLoading = true;
        state.tmeExpiredMembersError = null;
      })
      .addCase(fetchTMEExpiredMembersData.fulfilled, (state, action) => {
        state.tmeExpiredMembersLoading = false;
        state.tmeExpiredMembers = action.payload;
      })
      .addCase(fetchTMEExpiredMembersData.rejected, (state, action) => {
        state.tmeExpiredMembersLoading = false;
        state.tmeExpiredMembersError = action.error.message;
      })

      .addCase(fetchTMEFormSubmissionData.pending, (state) => {
        state.tmeLoading = true;
        state.error = null;
      })
      .addCase(fetchTMEFormSubmissionData.fulfilled, (state, action) => {
        state.tmeLoading = false;
        state.trainer_member_engagement = action.payload;
      })
      .addCase(fetchTMEFormSubmissionData.rejected, (state, action) => {
        state.tmeLoading = false;
        state.error = action.error.message;
      })

      .addCase(fetchTMEActiveUsersData.pending, (state) => {
        state.tmeActiveUsersLoading = true;
        state.tmeActiveUsersError = null;
      })
      .addCase(fetchTMEActiveUsersData.fulfilled, (state, action) => {
        state.tmeActiveUsersLoading = false;
        state.tmeActiveUsers = action.payload;
      })
      .addCase(fetchTMEActiveUsersData.rejected, (state, action) => {
        state.tmeActiveUsersLoading = false;
        state.tmeActiveUsersError = action.error.message;
      })

      .addCase(fetchStaffAttendanceReportData.pending, (state) => {
        state.staff_atttendance_loading = true;
        state.error = null;
      })
      .addCase(fetchStaffAttendanceReportData.fulfilled, (state, action) => {
        state.staff_atttendance_loading = false;
        state.staff_atttendance_report = action.payload;
      })
      .addCase(fetchStaffAttendanceReportData.rejected, (state, action) => {
        state.staff_atttendance_loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchLateCheckinsReportData.pending, (state) => {
        state.lateCheckinsReportDataLoading = true;
        state.lateCheckinsReportDataError = null;
      })
      .addCase(fetchLateCheckinsReportData.fulfilled, (state, action) => {
        state.lateCheckinsReportDataLoading = false;
        state.lateCheckinsReportData = action.payload;
      })
      .addCase(fetchLateCheckinsReportData.rejected, (state, action) => {
        state.lateCheckinsReportDataLoading = false;
        state.lateCheckinsReportDataError = action.error.message;
      })

      .addCase(fetchLateCheckinsStatsData.pending, (state) => {
        state.lateCheckinsStatsDataLoading = true;
        state.lateCheckinsStatsDataError = null;
      })
      .addCase(fetchLateCheckinsStatsData.fulfilled, (state, action) => {
        state.lateCheckinsStatsDataLoading = false;
        state.lateCheckinsStatsData = action.payload;
      })
      .addCase(fetchLateCheckinsStatsData.rejected, (state, action) => {
        state.lateCheckinsStatsDataLoading = false;
        state.lateCheckinsStatsDataError = action.error.message;
      })

      .addCase(fetchAgentReportDateWiseData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAgentReportDateWiseData.fulfilled, (state, action) => {
        state.loading = false;
        state.dateWiseAgentData = action.payload;
      })
      .addCase(fetchAgentReportDateWiseData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchAgentWiseReportData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAgentWiseReportData.fulfilled, (state, action) => {
        state.loading = false;
        state.AgentWiseData = action.payload;
      })
      .addCase(fetchAgentWiseReportData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchAgentReportTaskSopData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAgentReportTaskSopData.fulfilled, (state, action) => {
        state.loading = false;
        state.AgentReportTaskSopData = action.payload;
      })
      .addCase(fetchAgentReportTaskSopData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchTvData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTvData.fulfilled, (state, action) => {
        state.loading = false;
        state.TVData = action.payload;
      })
      .addCase(fetchTvData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchTvStakeHolderData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTvStakeHolderData.fulfilled, (state, action) => {
        state.loading = false;
        state.TVStakeHolderData = action.payload;
      })
      .addCase(fetchTvStakeHolderData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchAgreementReportData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAgreementReportData.fulfilled, (state, action) => {
        state.loading = false;
        state.agreementReport = action.payload;
      })
      .addCase(fetchAgreementReportData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchClosureReportData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchClosureReportData.fulfilled, (state, action) => {
        state.loading = false;
        state.closureReport = action.payload;
      })
      .addCase(fetchClosureReportData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchClosureReportListData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchClosureReportListData.fulfilled, (state, action) => {
        state.loading = false;
        state.closureReportList = action.payload;
      })
      .addCase(fetchClosureReportListData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchOneDayMembershipData.pending, (state) => {
        state.one_day_memberships_loading = true;
        state.error = null;
      })
      .addCase(fetchOneDayMembershipData.fulfilled, (state, action) => {
        state.one_day_memberships_loading = false;
        state.one_day_memberships = action.payload;
      })
      .addCase(fetchOneDayMembershipData.rejected, (state, action) => {
        state.one_day_memberships_loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchAbandonedCartData.pending, (state) => {
        state.abandonedCartDataLoading = true;
        state.error = null;
      })
      .addCase(fetchAbandonedCartData.fulfilled, (state, action) => {
        state.abandonedCartDataLoading = false;
        state.abandonedCartData = action.payload;
      })
      .addCase(fetchAbandonedCartData.rejected, (state, action) => {
        state.abandonedCartDataLoading = false;
        state.error = action.error.message;
      })
      .addCase(fetchAllTrainerData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllTrainerData.fulfilled, (state, action) => {
        state.loading = false;
        state.trainerData = action.payload;
      })
      .addCase(fetchAllTrainerData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchODMAllData.pending, (state) => {
        state.odmAllLoading = true;
        state.odmAllError = null;
      })
      .addCase(fetchODMAllData.fulfilled, (state, action) => {
        state.odmAllLoading = false;
        state.odmAll = action.payload;
      })
      .addCase(fetchODMAllData.rejected, (state, action) => {
        state.odmAllLoading = false;
        state.odmAllError = action.error.message;
      })

      .addCase(fetchGymwiseODMData.pending, (state) => {
        state.gymWiseODMLoading = true;
        state.gymWiseODMError = null;
      })
      .addCase(fetchGymwiseODMData.fulfilled, (state, action) => {
        state.gymWiseODMLoading = false;
        state.gymWiseODM = action.payload;
      })
      .addCase(fetchGymwiseODMData.rejected, (state, action) => {
        state.gymWiseODMLoading = false;
        state.gymWiseODMError = action.error.message;
      })
      .addCase(fetchTimeSheetData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTimeSheetData.fulfilled, (state, action) => {
        state.loading = false;
        state.timeSheetData = action.payload;
      })
      .addCase(fetchTimeSheetData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchSheetContentData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSheetContentData.fulfilled, (state, action) => {
        state.loading = false;
        state.sheetContentData = action.payload;
      })
      .addCase(fetchSheetContentData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchVersionListingData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchVersionListingData.fulfilled, (state, action) => {
        state.loading = false;
        state.versionData = action.payload;
      })
      .addCase(fetchVersionListingData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchGalleryData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGalleryData.fulfilled, (state, action) => {
        state.loading = false;
        state.galleryData = action.payload;
      })
      .addCase(fetchGalleryData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchCentralizedBenefitsData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCentralizedBenefitsData.fulfilled, (state, action) => {
        state.loading = false;
        state.centralizedBenefitsData = action.payload;
      })
      .addCase(fetchCentralizedBenefitsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchNotificationData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchNotificationData.fulfilled, (state, action) => {
        state.loading = false;
        state.notificationData = action.payload;
      })
      .addCase(fetchNotificationData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchTodayPTRevenueDetailData.pending, (state) => {
        state.ptRevenueTodayLoading = true;
        state.ptRevenueTodayError = null;
      })
      .addCase(fetchTodayPTRevenueDetailData.fulfilled, (state, action) => {
        state.ptRevenueTodayLoading = false;
        state.ptRevenueToday = action.payload;
      })
      .addCase(fetchTodayPTRevenueDetailData.rejected, (state, action) => {
        state.ptRevenueTodayLoading = false;
        state.ptRevenueTodayError = action.error.message;
      })

      .addCase(fetchTicketTatData.pending, (state) => {
        state.ticketTatLoading = true;
        state.ticketTatError = null;
      })
      .addCase(fetchTicketTatData.fulfilled, (state, action) => {
        state.ticketTatLoading = false;
        state.ticketTat = action.payload.data;
      })
      .addCase(fetchTicketTatData.rejected, (state, action) => {
        state.ticketTatLoading = false;
        state.ticketTatError = action.error.message;
      })

      .addCase(fetchUntrackedWatiLeadsData.pending, (state) => {
        state.untrackedWatiLeadsLoading = true;
        state.untrackedWatiLeadsError = null;
      })
      .addCase(fetchUntrackedWatiLeadsData.fulfilled, (state, action) => {
        state.untrackedWatiLeadsLoading = false;
        state.untrackedWatiLeads = action.payload;
      })
      .addCase(fetchUntrackedWatiLeadsData.rejected, (state, action) => {
        state.untrackedWatiLeadsLoading = false;
        state.untrackedWatiLeadsError = action.error.message;
      });
  },
});

export default apiSlice.reducer;
